export const translations = {
  en: {
    // AddEditExamDetails
    examDetailsQuestionRequired: 'Question text is required',
    examDetailsOptionRequired: 'Option cannot be empty',
    examDetailsFourOptions: 'There must be 4 options',
    examDetailsUniqueOptions: 'All options must be unique',
    examDetailsCorrectAnswerRequired: 'Correct answer must be selected',
    examDetailsCannotDeleteLast: 'Cannot delete the last question',
    examDetailsDeleteQuestionConfirm: 'Are you sure you want to delete this question?',
    examDetailsYesDelete: 'Yes, delete',
    examDetailsSaveQuestionsFail: 'Failed to save questions',
    examDetailsAtLeastOneQuestion: 'At least one question must be added',
    examDetailsQuestionErrorPrefix: 'Q{index}: ',
    examDetailsSaveQuestionsSuccess: 'Questions saved successfully',
    examDetailsSelectQuestionsToDelete: 'Please select questions to delete',
    examDetailsDeleteSelectedConfirm: 'Are you sure you want to delete the selected questions?',
    examDetailsDeleteSelectedSuccess: 'Questions deleted successfully',
    examDetailsInvalidFile: 'Please choose a supported file (DOCX, PDF, Images)',
    examDetailsFileSizeLimit: 'File size must be less than 20MB',
    examDetailsAiUploadSuccess: 'Questions uploaded successfully using AI',
    examDetailsAiUploadFail: 'Failed to upload questions using AI',
    examDetailsNoteSaveSuccess: 'Questions saved from note successfully',
    examDetailsAutoGenerateSaveFail: 'Failed to save auto-generated questions',
    examDetailsNoteExtractSuccess: 'Successfully extracted {count} questions from your notes! Saving...',
    examDetailsNoteNoQuestions: 'No suitable notes found or question extraction failed.',
    examDetailsNoteExtractFail: 'Failed to extract questions from the note',
    examDetailsNoteExtractError: 'An error occurred while extracting questions. Please make sure there are enough notes.',
    examDetailsHowManyQuestions: 'How many questions do you want to generate?',
    examDetailsNQuestions: '{n} Questions',
    examDetailsManualFallback: 'Okay, you can add questions manually or use file upload.',
    examDetailsInvalidQuestionCount: 'Please choose a number between 1 and 100 questions.',
    examDetailsGeneratedSaveSuccess: 'Generated questions saved successfully',
    examDetailsGeneratedCreateSuccess: 'Successfully created {count} questions! Saving...',
    examDetailsGeneratedCreateFail: 'No questions were created. Please try again.',
    examDetailsGenerateFail: 'Failed to generate questions',
    examDetailsGenerateError: 'An error occurred while generating questions. Please try again.',
    examDetailsDeleteImageFail: 'Failed to delete image from the server',
    examDetailsTeacherFallback: 'Teacher',
    examDetailsNotFound: 'Exam data not found',
    examDetailsWelcomeMessage: 'Welcome Mr. {name}! Would you like to create questions for this exam?',
    examDetailsCreateFromNote: 'Create from note',
    examDetailsPageTitle: 'Manage Exam Questions',
    examDetailsBack: 'Back',
    examDetailsMinutes: '{duration} Minutes',
    examDetailsRandomOrder: 'Random Order',
    examDetailsManualOrder: 'Manual Order',
    examDetailsAiUploadLoading: 'Uploading...',
    examDetailsAiUploadPlaceholder: 'Upload questions using Rafeeq Assistant',
    examDetailsAiUploadSubtext: 'Supported files: DOCX, PDF, Images - Max size: 20MB',
    examDetailsAiUploadButtonLoading: 'Uploading',
    examDetailsAiUploadButton: 'Choose File',
    examDetailsAiWarning: 'Warning: Rafeeq may generate questions with a small margin of error. Please review.',
    examDetailsDeselectAll: 'Deselect All',
    examDetailsSelectAll: 'Select All',
    examDetailsQuestionsManage: 'Manage Questions ({count} questions)',
    examDetailsQuestionsRandomNote: 'Questions will appear in random order to students',
    examDetailsSaveOrder: 'Save Order',
    examDetailsDeleteQuestions: 'Delete Questions',
    examDetailsSaveAll: 'Save All Questions',
    examDetailsQuestionN: 'Question {n}',
    examDetailsQuestionTextPlaceholder: 'Type the question text here...',
    examDetailsQuestionImage: 'Question Image (Optional)',
    examDetailsUploadImagePlaceholder: 'Upload Question Image',
    examDetailsUploadImageSubtext: 'Drag and drop the image here or click to choose',
    examDetailsUploadImageButton: 'Choose Image',
    examDetailsOptionPlaceholder: 'Option {letter}',
    examDetailsNoQuestionText: 'No question text',
    examDetailsConfirmDeleteImage: 'Confirm Image Deletion',
    examDetailsConfirmDeleteImageText: 'Are you sure you want to permanently delete this image from the question?',
    examDetailsCancel: 'Undo',
    examDetailsRafeeqAssistant: 'Rafeeq Assistant',
    examDetailsUpdateOrderSuccess: 'Question order updated successfully',
    examDetailsUpdateOrderFail: 'Failed to update question order',
    examDetailsDeleteImageSuccess: 'Image deleted successfully',
    examDetailsLoadingData: 'Loading exam details...',
    examDetailsSaving: 'Saving...',
    examDetailsQuestionTextLabel: 'Question Text',
    examDetailsChangeImage: 'Change Image',
    examDetailsDeleteImageBtn: 'Delete Image',
    examDetailsDeleteImageConfirmBtn: 'Delete Image',
    examDetailsAddQuestion: 'Add Question',
    examDetailsScratchpad: 'Scratchpad',

    // Alerts
    confirmDeleteTitle: 'Confirm Deletion',
    confirmDeleteText: 'Are you sure you want to delete this item?',
    cannotUndoAction: 'This action cannot be undone',
    deleteBtn: 'Delete',
    warningTitle: 'Warning',
    warningText: 'Are you sure you want to continue?',
    warningAttention: 'Please pay attention before proceeding',
    continueBtn: 'Continue',

    // ExamManager Remaining
    examLoadError: 'An error occurred while loading exams',
    examUpdateError: 'Failed to update exam',
    examUpdateSuccess: 'Exam updated successfully',
    examAddError: 'Failed to add exam',
    examAddSuccess: 'Exam added successfully',
    examSaveError: 'An error occurred while saving exam data',
    useScratchpad: 'Use scratchpad',
    examHoursFormat: '{hours}:{minutes} hour',
    examStartConfirmTitle: 'Confirm exam start',
    examStartConfirmText: 'Are you sure you want to start the exam "{title}"?',
    examStartConfirmYes: 'Yes, start exam',
    examStartSuccess: 'Exam started successfully',
    examResetConfirmTitle: 'Are you sure?',
    examResetConfirmText: 'The exam will be reset and all previous student grades for this exam will be erased. This action cannot be undone!',
    examResetConfirmYes: 'Yes, reset',
    examResetSuccess: 'Exam reset successfully',
    examResetError: 'Failed to reset exam',
    examStopConfirmTitle: 'Confirm exam stop',
    examStopConfirmText: 'Are you sure you want to stop the exam "{title}"?',
    examStopConfirmYes: 'Yes, stop exam',
    examStopSuccess: 'Exam stopped successfully',
    examStopError: 'Failed to stop exam',
    examSendResultsConfirmTitle: 'Confirm sending results',
    examSendResultsConfirmText: 'Are you sure you want to send the results of the exam "{title}" to the parents?',
    examSendResultsConfirmYes: 'Yes, send results',
    examSendResultsSuccess: 'Exam results sent to parents successfully',
    examSendResultsError: 'Failed to send exam results to parents',
    examDeleteSuccess: 'Exam deleted successfully',
    examDeleteError: 'An error occurred while deleting the exam',
    examPrintNoQuestions: 'There are no exam questions to print',
    examPrintFetchError: 'An error occurred while fetching exam questions',
    examAssignConfirmTitle: 'Confirm student assignment',
    examAssignConfirmText: 'Are you sure you want to assign the selected student to the exam "{title}"?',
    examAssignConfirmYes: 'Yes, assign student',
    examAssignSuccess: 'Student assigned to exam successfully',
    examAssignError: 'Failed to assign student to exam',
    dataLoadError: 'An error occurred while loading data',
    examStarting: 'Starting exam...',
    examStopping: 'Stopping exam...',
    examSendingResults: 'Sending results to parents...',
    examPrinting: 'Preparing exam for printing...',
    examLoadingExams: 'Loading exams...',
    examResetting: 'Resetting exam...',
    examUpcoming: 'Upcoming',
    examInProgress: 'In Progress',
    examDeleteConfirmTitle: 'Confirm exam deletion',
    examDeleteConfirmText: 'Are you sure you want to delete this exam?',
    examDatePrefix: 'Exam Date: ',
    examAssignStudentLabel: 'Assign student to exam: ',
    examAssigning: 'Assigning...',
    examAssignBtn: 'Assign',
    examInProgressModalTitle: 'In-Progress Exam Details',
    examCloseBtn: 'Close',
    examSubjectLabel: 'Subject: ',
    examClassLabel: 'Class: ',
    examStatusLabel: 'Status: ',
    examPassedStudents: 'Students who passed the exam:',
    examNoPassedStudents: 'No students have passed this exam yet.',
    examTestTitleLabel: 'Exam Title: ',
    examRetakeBtn: 'Retake Exam',
    examRetakeConfirmTitle: 'Confirm Retake Exam',
    examRetakeConfirmText: 'Are you sure you want to retake the exam for the student {name}?',
    examRetakeConfirmYes: 'Yes, retake',
    examRetakeSuccess: 'Exam retaken for student {name}',
    examRetakeError: 'Failed to retake exam for student',
    examResetSessionBtn: 'Reset Exam Session',
    examResetSessionConfirmTitle: 'Confirm Reset Session',
    examResetSessionConfirmText: 'Are you sure you want to reset the exam session for the student {name}?',
    examResetSessionConfirmYes: 'Yes, reset',
    examResetSessionSuccess: 'Exam session reset for student {name}',
    examResetSessionError: 'Failed to reset session for student',
    examNotCompletedStudentsTitle: 'Students not finished with exam: {title}',
    examNotCompletedStudentsFallback: 'Students not finished',
    examNoNotCompletedStudents: 'No students have not finished this exam.',

    // Dynamic Modal validation and UI
    invalidEmail: 'Invalid email address',
    mustBeNumeric: 'Must be a numeric value',
    minimumIs: 'The minimum is',
    maximumIs: 'The maximum is',
    invalidUrl: 'Invalid URL',
    invalidPhoneNumber: 'Invalid phone number',
    minChars: 'Minimum characters:',
    maxChars: 'Maximum characters:',
    invalidFormat: 'Invalid format',
    requiredField: 'Field is required',
    loadingOptions: 'Loading...',
    searchPlaceholder: 'Search...',
    noResultsFound: 'No results',
    dragAndDropFile: 'Drag and drop the file here or click to choose',
    changeFile: 'Change file',
    sendingData: 'Sending...',

    paidStatus: 'Paid',
    unpaidStatus: 'Unpaid',
    pendingStatus: 'Pending',
    courseLabel: 'Course',
    studentLabel: 'Student',
    paymentStatusLabel: 'Payment Status',
    subscriptionLoadError: 'An error occurred while loading subscriptions',
    subscriptionDeleteSuccess: 'Subscription deleted successfully',
    subscriptionDeleteError: 'An error occurred while deleting the subscription',
    subscriptionUpdateSuccess: 'Subscription updated successfully',
    subscriptionAddSuccess: 'Subscription added successfully',
    subscriptionSaveError: 'An error occurred while saving the subscription',
    deletingSubscription: 'Deleting subscription...',
    savingSubscription: 'Saving subscription...',
    loadingSubscriptions: 'Loading subscriptions...',
    courseSubscriptionsTitle: 'Course Subscriptions Management',
    addNewSubscription: 'Add New Subscription',
    editSubscription: 'Edit Subscription',
    addSubscriptionBtn: 'Add Subscription',
    updateSubscriptionBtn: 'Update Subscription',
    confirmDeleteSubscriptionTitle: 'Confirm Delete Subscription',
    confirmDeleteSubscriptionMessage: 'Are you sure you want to delete this subscription? The student will permanently lose access to the course.',
    noSubscriptionsAvailable: 'No subscriptions available',
    searchSubscriptionPlaceholder: 'Search for a subscription...',
    coursePrefix: 'Course: ',
    studentViewPreview: "Student View Preview",
    websitePreview: "Website Preview",
    livePreviewSubtitle: "Live Preview - For Reference Only",
    courseRequestsLoadError: 'An error occurred while loading course requests',
    confirmRequestTitle: 'Confirm Request',
    confirmRequestMessage: 'If confirmed, the student will be enrolled in this course and will have full access to its content.',
    confirmYesBtn: 'Yes, Confirm',
    addNoteTitle: 'Add Note',
    noteLabelOptional: 'Note (Optional)',
    notePlaceholder: 'Write your note here...',
    requestConfirmSuccess: 'Request confirmed successfully',
    requestConfirmError: 'An error occurred while confirming the request',
    rejectRequestTitle: 'Reject Request',
    rejectReasonLabel: 'Reason for Rejection',
    rejectReasonPlaceholder: 'Write the reason for rejection here...',
    rejectBtn: 'Reject',
    rejectReasonRequired: 'Reason for rejection is required',
    requestRejectSuccess: 'Request rejected successfully',
    requestRejectError: 'An error occurred while rejecting the request',
    requestDeleteSuccess: 'Request deleted successfully',
    requestDeleteError: 'An error occurred while deleting the request',
    statusPending: 'Pending',
    statusRejected: 'Rejected',
    statusConfirmed: 'Confirmed',
    statusUnknown: 'Unknown',
    deletingRequest: 'Deleting request...',
    loadingRequests: 'Loading requests...',
    courseRequestsTitle: 'Course Requests',
    rejectTooltip: 'Reject',
    searchRequestPlaceholder: 'Search for a request...',
    confirmDeleteRequestTitle: 'Confirm Delete Request',
    confirmDeleteRequestMessage: 'Are you sure you want to delete this request?',
    failedToLoadCourses: 'Failed to load courses',
    failedToLoadCourseDetails: 'Failed to load course details',
    courseDeletedSuccess: 'Course deleted successfully',
    courseDeleteFailed: 'An error occurred while deleting the course',
    courseHoursRecalculated: 'Course hours recalculated successfully',
    courseHoursRecalculateFailed: 'Failed to recalculate course hours',
    courseHoursRecalculateError: 'An error occurred while recalculating course hours',
    courseVisibilityChanged: 'Course visibility changed successfully',
    courseVisibilityChangeFailed: 'Failed to change course visibility',
    courseVisibilityChangeError: 'An error occurred while changing course visibility',
    courseNameRequired: 'Course name is required',
    courseDescriptionRequired: 'Course description is required',
    coursePriceRequired: 'Price is required',
    courseDiscountValue: 'Discount Value',
    courseCategory: 'Category',
    courseCategoryRequired: 'Category is required',
    courseCouponOptional: 'Coupon Code (Optional)',
    courseIsCertified: 'Is the course certified?',
    courseImage: 'Course Image',
    courseUpdatedSuccess: 'Course updated successfully',
    courseAddedSuccess: 'Course added successfully',
    courseManagementTitle: 'Course Management',
    courseManagementSubtitle: 'Manage and organize course details',
    subscriptionsTab: 'Subscriptions',
    registrationRequestsTab: 'Registration Requests',
    loadingCourses: 'Loading courses...',
    noCoursesYet: 'No courses yet',
    addYourFirstCourse: 'Add your first educational course',
    showCourse: 'Show Course',
    hideCourse: 'Hide Course',
    certified: 'Certified',
    notCertified: 'Not Certified',
    currencyEGP: 'EGP',
    calculating: 'Calculating...',
    recalculateHours: 'Recalculate Hours',
    confirmDeleteCourseTitle: 'Confirm Course Deletion',
    confirmDeleteCourseMessage: 'Are you sure you want to delete this course?',
    materialLabelPrefix: 'Material: ',
    createNewCourseTitle: 'Create New Course',
    createCourseBtn: 'Create Course',
    courseSaveError: 'An error occurred while saving the course',
    examTitleMinLength: 'Exam title must be at least 5 characters',
    examDurationInMinutes: 'Exam duration (in minutes)',
    durationInMinutes: 'Duration (in minutes)',
    examDurationMin: 'Exam duration must be greater than 0',
    questionWeightRequired: 'Question weight is required',
    questionWeightMin: 'Question weight must be at least 0.01',
    normalOrder: 'Normal Order',
    randomOrder: 'Random Order',
    examDescriptionOptional: 'Exam Description (Optional)',
    addNewExamTitle: 'Add New Exam',
    editExamTitle: 'Edit Exam Details',
    createExamBtn: 'Create Exam',
    updateExamBtn: 'Update Exam',
    examIdLabel: 'Exam ID',
    questionsCountLabel: 'Questions Count',
    statusLabel: 'Status',
    searchExamPlaceholder: 'Search for an exam...',
    noExamsAvailable: 'No exams available',
    stopExamTooltip: 'Stop Exam',
    sendToParentsTooltip: 'Send to Parents',
    examResultsTooltip: 'Exam Results',
    viewQuestionsTooltip: 'View Questions',
    printExamTooltip: 'Print Exam',
    assignStudentTooltip: 'Assign Student',
    examQuestionsTooltip: 'Exam Questions',
    startExamTooltip: 'Start Exam',
    viewUnfinishedStudentsTooltip: 'View Unfinished Students',
    actionText: 'Action',
    recordText: 'Record',
    recordActionsLabel: 'Record Actions',
    selectedLabel: 'Selected',
    activeColumnsLabel: 'Active Columns',
    currentlyDisplayedLabel: 'Currently Displayed',
    recordCountLabel: 'Record Count',
    pageSizeLabel: 'Page Size:',
    selectAll: 'Select All',
    resetAction: 'Reset',
    customizeColumns: 'Customize Columns',
    columnsText: 'Columns',
    rightClickForActions: 'Right click for actions',
    searchInAllColumns: 'Search in all columns...',
    noResultsAtThisTime: 'No results available at this time.',
    tryModifyingSearch: 'Try modifying your search or use filters.',
    noDataAvailable: 'No data available',
    noResultsSpace: ' No results',
    noResults: 'No results',
    search: 'Search',
    groupBy: 'Group By',
    noGrouping: 'No Grouping',
    groupItemsCount: '{count} items',
    home: 'Home',
    clearSearch: 'Clear Search',
    examUseScratchpad: 'Scratchpad',
    examUseScratchpadLabel: 'Enable Scratchpad',
    examUseScratchpadDescription: 'Allow students to use a scratchpad during the exam',
    resetSession: 'Reset Session',
    confirmResetSession: 'Are you sure you want to reset the session for this student?',
    failedToResetSession: 'Failed to reset session',
    reset: 'Reset',
    welcome: 'Welcome',
    loginSuccess: 'Login Successful',
    dashboard: 'Dashboard',
    exams: 'Exams',
    students: 'Students',
    reports: 'Reports',
    blog: 'Blog',
    profile: 'Profile',
    settings: 'Settings',
    activeExams: 'Active Exams',
    studentCount: 'Student Count',
    averageScore: 'Average Score',
    subscription: 'Subscription',
    remainingDays: 'Remaining Days',
    subscriptionDate: 'Subscription Date',
    expirationDate: 'Expiration Date',
    lastExam: 'Last Exam',
    recentlyAdded: 'Recently Added',
    lastCompletedExam: 'Last Completed Exam',
    noRecentExams: 'No recent exams',
    noCompletedExams: 'No completed exams',
    examNoExams: 'No exams found',
    features: 'Features',
    enabled: 'Enabled',
    disabled: 'Disabled',
    activity: 'Recent Activity',
    searchBlogs: 'Search blogs...',
    addBlog: 'Add Blog',
    editBlog: 'Edit Blog',
    create: 'Create',
    update: 'Update',
    blogTitle: 'Blog Title',
    description: 'Description',
    content: 'Content',
    category: 'Category',
    selectCategory: 'Select Category',
    delete: 'Delete',
    cancel: 'Cancel',
    confirmDeleteBlog: 'Are you sure you want to delete this blog?',
    noBlogs: 'No blogs found',
    addImage: 'Tap to add image',
    loading: 'Loading...',
    blogTitleRequired: 'Blog title is required',
    blogDescriptionRequired: 'Blog description is required',
    blogContentRequired: 'Blog content is required',
    blogCategoryRequired: 'Blog category is required',
    categoryRequired: 'Category is required',
    titleRequired: 'Title is required',
    descriptionRequired: 'Description is required',
    contentRequired: 'Content is required',
    appName: 'EMt7any Platform',
    daysRemaining: 'days remaining',
    logout: 'Logout',
    blogs: 'Blogs',
    reportsAndStatistics: 'Reports & Statistics',
    downloadReport: 'Download Report',
    totalExams: 'Total Exams',
    totalStudents: 'Total Students',
    showStudentsHaveNotCompleted: 'Show Students Have Not Completed',
    completionRate: 'Completion Rate',
    examReports: 'Exam Reports',
    studentReports: 'Student Reports',
    searchExams: 'Search exams...',
    searchStudents: 'Search students...',
    examName: 'Exam Name',
    examNoResults: 'No results found for this exam.',
    examResetFilter: 'Reset Filter',
    date: 'Date',
    passingRate: 'Passing Rate',
    studentName: 'Student Name',
    examsTaken: 'Exams Taken',
    lastExamDate: 'Last Exam Date',
    improvement: 'Improvement',
    notifications: 'Notifications',
    notificationError: 'An error occurred while fetching notifications',
    noNotifications: 'No notifications',
    markAllAsRead: 'Mark all as read',
    refreshing: 'Refreshing...',
    forbiddenTitle: 'Access Forbidden',
    forbiddenDefaultMessage: 'You are not authorized to access this page.',
    welcomeBack: 'Welcome Back!',
    signInToContinue: 'Sign in to continue',
    username: 'Username',
    password: 'Password',
    male: 'Male',
    female: 'Female',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',
    show: 'Show',
    hide: 'Hide',
    sort: 'Sort',
    mozakaraManagement: 'Mozakara Management',
    addMozakara: 'Add New Mozakara',
    mozakaraManagementDesc: 'Add, edit, and manage your notes and materials',
    mozakaraTitle: 'Mozakara Title',
    grade: 'Grade',
    attachments: 'Attachments',
    createdDate: 'Created Date',
    noMozakara: 'No mozakara found. Start by adding a new one.',
    searchMozakara: 'Search in mozakara...',
    mozakaraDeleteConfirmTitle: 'Delete Mozakara',
    mozakaraDeleteConfirmMessage: 'Are you sure you want to delete this mozakara? This action cannot be undone.',
    files: 'Files',
    noFiles: 'None',
    untitled: 'Untitled',
    mozakaraLoadFailed: 'Failed to load mozakara',
    mozakaraDeleteSuccess: 'Mozakara deleted successfully',
    mozakaraDeleteFailed: 'Failed to delete mozakara',
    addEditMozakaraBack: 'Back',
    addEditMozakaraTitleAdd: 'Add New Mozakara',
    addEditMozakaraTitleEdit: 'Edit Mozakara',
    addEditMozakaraSubtitleAdd: 'Fill in details to create a new mozakara for your students',
    addEditMozakaraSubtitleEdit: 'Update mozakara details and manage attachments',
    addEditMozakaraInfoSection: 'Mozakara Information',
    addEditMozakaraTitleLabel: 'Mozakara Title',
    addEditMozakaraTitlePlaceholder: 'Example: English notes - Term 1',
    addEditMozakaraClassLabel: 'Class',
    addEditMozakaraClassPlaceholder: 'Select class',
    addEditMozakaraDescriptionLabel: 'Description',
    addEditMozakaraDescriptionPlaceholder: 'Write a short description...',
    addEditMozakaraCurrentAttachments: 'Current attachments',
    addEditMozakaraChooseFile: 'Choose File',
    addEditMozakaraChangeFile: 'Change file',
    addEditMozakaraAddSlot: 'Add another file slot',
    addEditMozakaraRemoveSlot: 'Remove slot',
    addEditMozakaraNoFile: 'No file selected',
    addEditMozakaraCreating: 'Creating...',
    addEditMozakaraUpdating: 'Updating...',
    addEditMozakaraRequiredFields: 'Please fill required fields',
    addEditMozakaraRequiredAttachment: 'Please add at least one attachment when creating mozakara',
    addEditMozakaraInvalidFileType: 'File type is not allowed. Allowed: jpg, png, pdf, doc, xls, ppt',
    addEditMozakaraMaxSizeError: 'File exceeds maximum size (100 MB)',
    addEditMozakaraDeleteAttachmentTitle: 'Delete attachment',
    addEditMozakaraDeleteAttachmentMessage: 'Are you sure you want to delete this attachment?',
    addEditMozakaraDeleteAttachmentSuccess: 'Attachment deleted successfully',
    addEditMozakaraDeleteAttachmentFailed: 'Failed to delete attachment',
    addEditMozakaraOpenAttachmentFailed: 'Failed to open attachment',
    addEditMozakaraInvalidAttachmentLink: 'Attachment link is not available',
    addEditMozakaraCreateSuccess: 'Mozakara created successfully',
    addEditMozakaraUpdateSuccess: 'Mozakara updated successfully',
    addEditMozakaraSaveFailed: 'An error occurred while saving',
    addEditMozakaraLoadFailed: 'Failed to load data',
    addEditMozakaraFileSlot: 'Attachment',
    addEditMozakaraUploadingHint: 'Allowed: images, PDF, Word, Excel, PPT - max 100MB',
    addEditMozakaraAttachmentFallback: 'Attachment',
    signIn: 'Sign In',
    emailOrPhone: 'Email or Phone Number',
    enterEmailOrPhone: 'Enter your email or phone number',
    emailOrPhoneRequired: 'Email or Phone Number is required',
    forceUpdateTitle: 'Update Required',
    updateAvailableTitle: 'Update Available',
    forceUpdateMessage: 'A new version of the app is required to continue. Please update to the latest version.',
    updateAvailableMessage: 'A new version of the app is available with improvements and bug fixes.',
    currentVersion: 'Current Version',
    latestVersion: 'Latest Version',
    releaseNotes: 'Release Notes',
    failedToLoadExams: 'Failed to load exams.',
    updateNow: 'Update Now',
    checking: 'Checking...',
    updateCheckFailed: 'Failed to check for updates',
    updateDownloadTitle: 'Download Update',
    updateDownloadMessage: 'The download link has been copied to your clipboard.',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied to clipboard',
    updateDownloadError: 'Unable to open download link',
    highPriority: 'High Priority',
    userName: 'User Name',
    signingIn: 'Signing in...',
    error: 'Error',
    fillAllFields: 'Please fill in all fields',
    dontHaveAccount: "Don't have an account?",
    signUp: 'Sign Up',
    profileLoadFailed: 'Failed to load profile data',
    profileUpdateFailed: 'Failed to update profile',
    examQuestionNumber: 'Question Number',
    loadingData: 'Loading data...',
    editProfile: 'Edit Profile',
    changeImage: 'Change Image',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    qualification: 'Qualification',
    passwordPlaceholder: 'Password (leave blank if unchanged)',
    confirmDelete: 'Confirm Delete',
    saveChanges: 'Save Changes',
    examDetailsLoadFailed: 'Failed to load exam details',
    examInfo: 'Exam Info',
    studentInfo: 'Student Info',
    examDeleteSelectedSuccess: 'Selected questions deleted successfully',
    examSaveFailed: 'Failed to save exam',
    confirmDeleteImageTitle: 'Delete Image',
    confirmDeleteImageMessage: 'Are you sure you want to delete this image?',
    imageDeleteSuccess: 'Image deleted successfully',
    imageDeleteFailed: 'Failed to delete image',
    imagePickerError: 'An error occurred while picking the image',
    imageSizeTooLarge: 'Image size must be less than 10MB',
    maxImageSizeHint: '(Max 10MB)',
    examDetails: 'Exam Details',
    examProgress: 'Exam Progress',
    examDeleteFailed: 'Failed to delete questions',
    examNoQuestions: 'No questions available',
    examStopConfirm: 'Are you sure you want to stop this exam?',
    examStopConfirmMessage: 'This action will stop the exam and cannot be undone',
    examStopYes: 'Yes',
    examStopNo: 'No',
    examDeleteSelected: 'Delete Selected',
    allowExamOnMobile: 'Allow Exam on Mobile',
    allowExamOnMobileDescription: 'Enable taking exams on mobile devices',
    failedToUpdateSetting: 'Failed to update setting',
    examAddQuestion: 'Add Question',
    examAddFirstQuestion: 'Add First Question',
    examEditQuestion: 'Edit Question',
    examCancelQuestion: 'Cancel',
    examSaveQuestion: 'Save Question',
    examQuestionText: 'Question Text',
    examOption: 'Option',
    examQuestionValidationText: 'Please enter the question text',
    examQuestionValidationOption: 'Please enter all options',
    examQuestionValidationDuplicate: 'Duplicate options are not allowed',
    examQuestionValidationAnswer: 'Please select the correct answer',
    examMaterial: 'Material',
    examClass: 'Class',
    examDate: 'Exam Date',
    questionSingular: 'Question Singular',
    questionsPlural: 'Questions Plural',
    examTime: 'Exam Time',
    examDuration: 'Duration',
    examQuestions: 'Questions',
    examSubject: 'Subject',
    examLoading: 'Loading exam details...',
    examDetailsLoading: 'Loading exam details...',
    printing: 'Printing...',
    examEditNotAllowed: 'Editing this exam is not allowed',
    examStartFailed: 'Failed to start the exam',
    examStopFailed: 'Failed to stop the exam',
    faildToLoadExams: 'Failed to load exams',
    examStop: 'Stop Exam',
    examResetConfirm: 'Are you sure you want to reset this exam?',
    examResetNo: 'No',
    examResetYes: 'Yes',
    examStatus: 'Exam Status',
    examReset: 'Reset Exam',
    examResetFailed: 'Failed to reset the exam',
    examDeleteNotAllowed: 'Deleting this exam is not allowed',
    confirmDeleteExam: 'Confirm Delete',
    examDeleteConfirm: 'Are you sure you want to delete this exam?',
    examDeleteNo: 'No',
    examDeleteYes: 'Yes',
    editExam: 'Edit Exam',
    examStart: 'Start Exam',
    examDelete: 'Delete Exam',
    examManagement: 'Exam Management',
    addExam: 'Add Exam',
    examSearchPlaceholder: 'Search exams...',
    examAllStatuses: 'All Statuses',
    examOngoing: 'Ongoing',
    examCompleted: 'Completed',
    examTitleRequired: 'Exam title is required',
    examMaterialRequired: 'Material is required',
    examClassRequired: 'Class is required',
    examDateRequired: 'Exam date is required',
    examTimeRequired: 'Exam time is required',
    examDurationRequired: 'Exam duration is required',
    examCancel: 'Cancel',
    examCancelConfirm: 'Are you sure you want to cancel?',
    examCancelNo: 'No',
    examCancelYes: 'Yes',
    examTitle: 'Exam Title',
    examTitlePlaceholder: 'Enter exam title',
    examDurationPlaceholder: 'Enter exam duration',
    examMaterialSelect: 'Select Material',
    examClassSelect: 'Select Class',
    examDescription: 'Description',
    examDescriptionPlaceholder: 'Enter exam description',
    examQuestionWeight: 'Question Weight',
    examQuestionWeightPlaceholder: 'Enter question weight',
    examQuestionWeightHint: 'Example: If you have 5 questions with weight 2, the total score will be 10 points',
    examQuestionWeightRequired: 'Question weight must be at least 1',
    examRandomQuestions: 'Random Questions',
    examRandomQuestionsLabel: 'Enable Random Questions',
    examRandomQuestionsDescription: 'Questions will be displayed in random order for each student',
    examQuestionOrdering: 'Question Ordering',
    examQuestionOrderingDescription: 'Use the up/down arrows to reorder questions',
    examQuestionOrderingDisabled: 'Question ordering is disabled when random questions is enabled',
    examQuestionOrderUpdated: 'Question order updated successfully',
    examQuestionOrderUpdateFailed: 'Failed to update question order',
    examNoQuestionsSubtitle: 'Start by adding questions or upload a document',
    examLoadFailed: 'Failed to load exam data',
    examUpdate: 'Update',
    examSave: 'Save',
    examFilter: 'Filter Exams',
    examPrint: 'Print Exam',
    examPrintSuccess: 'Exam printed successfully',
    examPrintFailed: 'Failed to print exam',
    examTest: 'Test',
    examInstructions: 'Instructions',
    examAnswerSheet: 'Answer Sheet',
    examTotalScore: 'Total Score',
    examDegrees: 'Degrees',
    examResults: 'Results',
    viewResults: 'View Results',
    examAssignUser: 'Assign User to Exam',
    examAssignUserSuccess: 'User assigned to exam successfully',
    examAssignUserFailed: 'Failed to assign user to exam',
    examAssignUserConfirm: 'Are you sure you want to assign a user to this exam?',
    examAssignUserConfirmMessage: 'This will assign the selected user to take this exam',
    examAssignUserYes: 'Yes',
    examAssignUserNo: 'No',
    examAssignUserLoading: 'Assigning user...',
    examSelectStudent: 'Select Student',
    examSelectStudentTitle: 'Choose a student to assign to this exam',
    examSelectStudentPlaceholder: 'Select a student...',
    examSelectStudentRequired: 'Please select a student',
    examAssignStudent: 'Assign Student',
    examCancelSelection: 'Cancel',
    language: 'Language',
    appLanguage: 'Application Language',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    blogManagement: 'Blog Management',
    addNewBlog: 'Add New Blog',
    edit: 'Edit',
    deleteConfirmation: 'Are you sure you want to delete this blog?',
    blogImage: 'Blog Image',
    title: 'Title',
    enterTitle: 'Enter title',
    enterDescription: 'Enter description',
    enterContent: 'Enter content',
    saving: 'Saving...',
    save: 'Save',
    deleting: 'Deleting...',
    blogLoadFailed: 'Failed to load blogs',
    categoriesLoadFailed: 'Failed to load categories',
    blogDeletedSuccess: 'Blog deleted successfully',
    blogDeleteFailed: 'Failed to delete blog',
    blogUpdatedSuccess: 'Blog updated successfully',
    blogCreatedSuccess: 'Blog created successfully',
    blogSaveFailed: 'Failed to save blog',
    examCompletion: 'Exam Completion',
    loadingBlogs: 'Loading blogs...',
    studentManagement: 'Student Management',
    profilePicture: 'Profile Picture',
    addStudent: 'Add Student',
    studentLoading: 'Loading students...',
    noStudents: 'No students found',
    studentLoadError: 'Failed to load students',
    studentDeleteError: 'Failed to delete student',
    studentStatusError: 'Failed to update student status',
    studentDeleteConfirm: 'Are you sure you want to delete',
    studentDeleteAttension: 'All related data of the student will be deleted and cannot be undone',
    editStudent: 'Edit Student',
    active: 'Active',
    inactive: 'Inactive',
    class: 'Class',
    gender: 'Gender',
    enterFullName: 'Enter full name',
    selectClass: 'Select Class',
    selectMaterial: 'Select Material',
    selectImage: 'Select Image',
    enterEmail: 'Enter email',
    enterPhone: 'Enter phone',
    emailForParent: 'Email for Parent',
    phoneForParent: 'Phone for Parent',
    enterEmailForParent: 'Enter email for parent',
    enterPhoneForParent: 'Enter phone for parent',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    phoneRequired: 'Phone is required',
    genderRequired: 'Gender is required',
    classRequired: 'Class is required',
    materialRequired: 'Material is required',
    passwordRequired: 'Password is required',
    passwordOptional: 'Password is optional',
    fullNameRequired: 'Full name is required',
    studentSaveError: 'Failed to save student',
    studentUpdateSuccess: 'Student updated successfully',
    studentAddSuccess: 'Student added successfully',
    examSettings: 'Exam Settings',
    sendToParents: 'Send to Parents',
    sendingToParents: 'Sending to Parents...',
    passingScore: 'Passing Score',
    honorBoardExamsCount: 'Honor Board Exams Count',
    honorBoardExamsCountDescription: 'Number of exams to display on honor board (1-50)',
    passingScoreDescription: 'Minimum score required to pass an exam (1-100)',
    failedToSavePassingScore: 'Failed to save passing score',
    noReportYet: 'No reports yet',
    courses: 'Courses',
    coupon: 'Coupon',
    discount: 'Discount',
    price: 'Price',
    courseName: 'Course Name',
    courseDescription: 'Course Description',
    coursePrice: 'Course Price',
    courseDiscount: 'Course Discount',
    courseHours: 'Course Hours',
    views: 'Views',
    rate: 'Rate',
    hours: 'Hours',
    courseCover: 'Course Cover',
    courseMaterial: 'Course Material',
    courseClass: 'Course Class',
    addNewCourse: 'Add New Course',
    courseEdit: 'Edit Course',
    courseDelete: 'Delete Course',
    courseSave: 'Save Course',
    courseUpdate: 'Update Course',
    courseCancel: 'Cancel',
    courseCancelConfirm: 'Are you sure you want to cancel?',
    enterCourseName: 'Enter course name',
    enterCourseDescription: 'Enter course description',
    enterCoursePrice: 'Enter course price',
    enterCourseDiscount: 'Enter course discount',
    enterCourseHours: 'Enter course hours',
    enterCourseCover: 'Enter course cover',
    enterCouponCode: 'Enter coupon code',
    enterCouponDescription: 'Enter coupon description',
    enterCouponDiscount: 'Enter coupon discount',
    enterCouponExpiryDate: 'Enter coupon expiry date',
    enterCouponCodeRequired: 'Coupon code is required',
    enterCouponDescriptionRequired: 'Coupon description is required',
    enterPrice: 'Enter price',
    clickToUpload: 'Click to upload',
    saveCourse: 'Save Course',
    enterDiscountOptional: 'Enter discount (optional)',
    enterCouponOptional: 'Enter coupon (optional)',
    updateCourse: 'Update Course',
    editCourse: 'Edit Course',
    maintenanceModeTitle: 'Maintenance Mode',
    maintenanceModeActionsDisabledMessage: 'The actions are disabled in maintenance mode',
    maintenanceModeActive: 'Maintenance mode is active',
    profileUpdateSuccess: 'Profile updated successfully',
    noCoursesFound: 'No courses found',
    noCategoriesFound: 'No categories found',
    noMaterialsFound: 'No materials found',
    pullToRefresh: 'Pull to refresh',
    examResultNoStudents: 'No results found for this exam.',
    examResultLoading: 'Loading results...',
    examResultError: 'Failed to fetch results',
    studentsNotCompletedExam: 'Students Not Completed Exam',
    studentsCompletedExam: 'Students Completed Exam',
    statusNotCompleted: 'Status: Not Completed',
    noStudentsFound: 'No students found.',
    failedToFetchData: 'Failed to fetch data',
    id: 'ID',
    restartExam: 'Restart Exam',
    restartExamConfirmation: 'Are you sure you want to restart this exam for this student?',
    restart: 'Restart',
    failedToRestart: 'Failed to restart exam',
    imagePickError: 'Failed to pick image',
    storagePermissionRequired: 'Storage permission is required',
    fileSelected: 'File selected successfully',
    noFileSelected: 'No file selected',
    fileProcessedSuccess: 'File processed successfully',
    fileProcessError: 'Failed to process file',
    processFile: 'Process File',
    processFileWithAI: 'Process with AI',
    uploadWithAI: 'Upload with AI',
    selectDocument: 'Select Document',
    selectedFile: 'Selected File',
    readyToProcessWithAI: 'Ready to process with AI',
    unknownSize: 'Unknown size',
    chooseFileToUpload: 'Choose a file to upload and process with AI',
    acceptedFormats: 'Accepted formats:',
    maxSize: 'Max:',
    chooseFile: 'Choose File',
    selectThisFile: 'Select This File',
    fileSizeMustBeLess: 'File size must be less than',
    pleaseSelectFileWithTypes: 'Please select a file with one of these types:',
    errorReadingFile: 'Error reading file. Please try again.',
    errorSendingFileData: 'Error sending file data. Please try again.',
    deleteAllQuestions: 'Delete All Questions',
    deleteAllQuestionsConfirm: 'Are you sure you want to delete all questions?',
    deleteAllQuestionsSuccess: 'All questions deleted successfully',
    deleteAllQuestionsFailed: 'Failed to delete all questions',
    noQuestionsToDelete: 'No questions to delete',
    confirmDeleteAllQuestionsTitle: 'Delete All Questions',
    confirmDeleteAllQuestionsMessage: 'Are you sure you want to delete all questions? This action cannot be undone.',
    confirm: 'Confirm',
    reportsSubtitle: 'Comprehensive analytics and insights',
    noReportYetSubtitle: 'No reports available yet. Check back later!',
    userNotAuthenticated: 'User not authenticated',
    failedToLoadProfileData: 'Failed to load profile data',
    imageSelectedSuccessfully: 'Image selected successfully',
    free: 'Free',
    manageYourProfile: 'Manage your profile',
    teacherName: 'Teacher Name',
    teacherRole: 'Teacher Role',
    personalInformation: 'Personal Information',
    accountStats: 'Account Statistics',
    accountType: 'Account Type',
    accountStatus: 'Account Status',
    somethingWentWrong: 'Something went wrong. Please try again.',
    retry: 'Retry',
    manageYourClasses: 'Manage your classes',
    navigation: 'Navigation',
    customizeYourExperience: 'Customize your experience and preferences',
    customizeAppearance: 'Customize how the app looks',
    configureExamPreferences: 'Configure exam preferences and rules',
    settingsFooter: 'Your settings are automatically saved and synchronized across all devices',
    restartRequired: 'Restart Required',
    restartAppToApplyChanges: 'Please restart the app to apply language changes',
    restartNow: 'Restart Now',
    later: 'Later',
    languageChangeFailed: 'Failed to change language',
    saveChangesDescription: 'Save your current settings',
    settingsSavedSuccessfully: 'Settings saved successfully',
    failedToSaveSettings: 'Failed to save settings',
    cancelling: 'Cancelling...',
    manageYourExams: 'Manage and organize your exams efficiently',
    completed: 'Completed',
    completedStudents: 'Completed Students',
    studentsWhoFinishedExam: 'Students who finished the exam',
    noStudentsCompletedYet: 'No students have completed this exam yet',
    restarting: 'Restarting',
    tryDifferentSearch: 'Try searching with different keywords',
    allStudentsCompleted: 'All students have completed this exam',
    searchQuestions: 'Search questions...',
    noSearchResults: 'No questions found',
    searchResults: 'Search results',
    searchInQuestions: 'Search in questions',
    searchInOptions: 'Search in options',
    searchInAll: 'Search in all fields',
    manageYourStudents: 'Manage and organize your students efficiently',
    studentNoResults: 'No students found for this search',
    filter: 'Filter',
    shareError: 'Failed to share student information',
    copying: 'Copying...',
    manageYourBlogs: 'Manage and organize your blogs efficiently',
    characters: 'characters',
    success: 'Success',
    ok: 'OK',
    signupTitle: 'Join us as a teacher',
    signupPersonalInfo: 'Personal Information',
    signupAcademicInfo: 'Academic Information',
    signupProfileImageTitle: 'Profile Image (Optional)',
    signupImagePlaceholder: 'Tap to choose a profile image',
    signupImageOptionalHint: 'Uploading an image is optional and you can skip this step.',
    confirmPassword: 'Confirm Password',
    enterConfirmPassword: 'Re-enter your password',
    enterQualification: 'Enter your qualification',
    aboutPlaceholder: 'Write a short bio about you and your experience...',
    signupNext: 'Next',
    signupPrev: 'Previous',
    signupAsTeacher: 'Register as Teacher',
    confirmPasswordRequired: 'Confirm password is required',
    passwordMismatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    signupPhoneInvalid: 'Phone number must start with 01 and be 11 digits',
    signupAboutMax: 'Description must not exceed 300 characters',
    signupClassesRequired: 'Select at least one class',
    otpTitle: 'Verify your email',
    otpSubtitle: 'A 6-digit verification code has been sent to your email:',
    otpSending: 'Sending verification code...',
    otpSent: 'Verification code has been sent to your email.',
    otpCodeLabel: 'Verification Code',
    otpPlaceholder: 'Enter the 6-digit',
    otpVerifying: 'Verifying...',
    otpConfirm: 'Confirm Code',
    otpResend: 'Resend code',
    didntReceiveCode: "Didn't receive the code?",
    otpInvalid: 'The verification code is invalid or has expired',
    otpSendError: 'An error occurred while sending the verification code',
    otpVerifyError: 'An error occurred while verifying the code',
    otpVerifySuccess: 'Verified successfully, you can log in now.',
    otpMissingData: 'Please go back and register again. Data is incomplete.',
    otpRequired: 'Please enter the 6-digit verification code',
    checkWhatsApp: 'Check WhatsApp',
    codeSentViaWhatsApp: 'Verification code sent via WhatsApp',
    rafiqWelcome: 'Hello! I am Rafiq, your assistant for generating exam questions.',
    rafiqSubtitle: 'Your smart assistant for creating exam questions',
    rafiqInputPlaceholder: 'Describe the questions you want to generate...',
    rafiqGenericReply: 'Your request has been received and processed.',
    rafiqSelectCountTitle: 'Choose how many questions to generate:',
    rafiqNoDataToAnalyze: 'It seems the student has no data to analyze',
    subscriptionDetails: 'Subscription Details',
    planInformation: 'Plan Information',
    planName: 'Plan Name',
    planPeriod: 'Plan Period',
    planPrice: 'Plan Price',
    subscriptionType: 'Subscription Type',
    subscriptionDates: 'Subscription Dates',
    day: 'Day',
    days: 'Days',
    planFeatures: 'Plan Features',
    notes: 'Notes',
    viewDetails: 'View Details',
    promoted: 'Promoted',
    delayedDays: 'Delayed Days',
    lastDelayDate: 'Last Delay Date',
    timeEstimation: 'Time Estimation',
    activeAddons: 'Active Add-ons',
    addonCount: 'addon',
    featuredAddon: 'Featured Add-on',
    addonExtraValue: 'Extra Value',
    noInternetTitle: 'Oops! No Internet Connection',
    noInternetSubTitle: 'You need Wi-Fi or mobile data to continue',
    noInternetToast: 'Still no internet, try again',
    refresh: 'Try Again',
    studentLookupsLoadError: 'Failed to load class and subject data',
    studentNotFound: 'Student not found',
    studentProfileLoadError: 'Failed to load student profile data',
    studentDeleteSuccess: 'Student deleted successfully',
    studentActivateSuccess: 'Student activated successfully',
    studentDeactivateSuccess: 'Student deactivated successfully',
    currentClass: 'Current Class',
    currentMaterial: 'Current Material',
    nameLettersOnly: 'Name must contain only letters',
    studentNameRequired: 'Student name is required',
    invalidPhoneFormat: 'Invalid phone number format',
    passwordMinLengthHint: 'Password must be at least 6 characters',
    studentImageOptional: 'Student Image (Optional)',
    studentUpdateError: 'Failed to update student profile',
    studentAddFailed: 'Failed to add student',
    notSpecified: 'Not specified',
    studentInfoLabel: 'Student Information:',
    namePrefix: 'Name:',
    emailPrefix: 'Email:',
    phonePrefix: 'Phone:',
    usernamePrefix: 'Username:',
    passwordPrefix: 'Password:',
    classPrefix: 'Class:',
    materialPrefix: 'Material:',
    statusPrefix: 'Status:',
    studentIdPrefix: 'Student ID:',
    studentInfoTitlePrefix: 'Student Info - ',
    studentInfoCopied: 'Student information copied to clipboard',
    addNewStudent: 'Add New Student',
    transferClass: 'Transfer Class',
    transferClassTitle: 'Transfer Students Between Classes',
    oldClass: 'From Class (Old)',
    newClass: 'To Class (New)',
    classTransferSuccess: 'Students transferred successfully',
    classTransferError: 'Failed to transfer students',
    classesMustBeDifferent: 'Old and new classes must be different',
    transferWarningTitle: 'Confirm Class Transfer',
    transferWarningMessage: 'Are you sure you want to transfer all students from the old class to the new class?',
    transferWarningAttention: 'This will move all assigned students. This action cannot be easily undone.',
    editStudentProfile: 'Edit Student Profile',
    updateStudentData: 'Update Student Data',
    addStudentBtn: 'Add Student',
    confirmStudentDeleteTitle: 'Confirm Student Deletion',
    confirmStudentDeleteMessage: 'Are you sure you want to delete this student?',
    emailLabelPrefix: 'Email: ',
    studentIdLabel: 'Student ID',
    hidePassword: 'Hide Password',
    showPassword: 'Show Password',
    materialLabel: 'Material',
    viewTooltip: 'View',
    shareStudentInfoTooltip: 'Share Student Information',
    deactivateTooltip: 'Deactivate',
    activateTooltip: 'Activate',
    searchStudentsPlaceholder: 'Search for a student...',
    noStudentsAvailable: 'No students available',
    confirmStatusChangeTitle: 'Confirm Status Change',
    statusChangeWarningText: 'The student will be blocked from accessing the system',
    backToList: 'Back to List',
    noSubscriptionData: 'No subscription data available',
    statusExpired: 'Expired',
    remainingDaysLabel: 'Remaining Days',
    nDays: '{count} Days',
    subscriptionPeriod: 'Subscription Period',
    renewSubscription: 'Renew Subscription',
    startDate: 'Start Date',
    totalDays: 'Total Days',
    studentLimit: 'Student Limit',
    studentLimitValue: 'Remaining {remaining} out of total {limit} students',
    storageLimit: 'Storage Limit',
    storageLimitValue: 'Remaining {remaining} GB out of total {limit} GB',
    delayedDaysTitle: 'Delayed Days',
    delayedDaysCount: 'Number of Delayed Days',
    lastDelayDateLabel: 'Last Delay Date',
    addonsCount: '{count} Add-ons',
    availableFeatures: 'Available Features',
    featuresCount: '{count} Features',
    settingsSaveSuccess: 'Settings saved successfully',
    settingsLoadError: 'An error occurred while loading settings',
    loadingSettings: 'Loading settings...',
    systemSettings: 'System Settings',
    systemSettingsSubtitle: "Customize learning and exam experiences to fit your students' needs",
    autoAppliedInfoNote: 'These settings are automatically applied to all new exams.',
    examSettingsTitle: 'Exams and Evaluation Settings',
    examSettingsDescription: 'Manage exam rules, grades, and honor board',
    defaultPassingScoreLabel: 'Default Passing Score (%)',
    defaultPassingScoreDesc: 'Minimum percentage required to pass the exam',
    allowMobileDevicesLabel: 'Allow Mobile Devices',
    allowMobileDevicesDesc: 'Enable students to take exams via smartphones',
    honorBoardExamsCountDesc: 'Number of recent exams calculated in the honor board evaluation',
    blogTitleMinError: 'Blog title must be at least 3 characters',
    blogTitleMaxError: 'Blog title must not exceed 100 characters',
    blogShortDescription: 'Short Description',
    blogDescMinError: 'Blog description must be at least 10 characters',
    blogDescMaxError: 'Blog description must not exceed 400 characters',
    blogContentMinError: 'Blog content must be at least 20 characters',
    blogCategory: 'Category',
    blogDetailsLoadFailed: 'Failed to load blog details',
    createNewBlog: 'Create New Blog',
    updateBlog: 'Update Blog',
    saveBlog: 'Save Blog',
    confirmDeleteBlogTitle: 'Confirm Delete Blog',
    categoryPrefix: 'Category: ',
    blogUpdateFailed: 'Failed to update blog',
    blogCreateFailed: 'Failed to add blog',
    searchBlogPlaceholder: 'Search for a blog...',
    noBlogsAvailable: 'No blogs available',
    filesCount: '{count} Files',
    averageTimeTaken: 'Average Time Taken',
    averageTime: 'Average Time',
    reportDownloadSuccess: 'Report downloaded successfully',
    reportDownloadFailed: 'Failed to download report',
    recentlyAddedStudents: 'Recently Added Students',
    passingStudents: 'Passing',
    failingStudents: 'Failing',
    notCompleted: 'Not Completed',
    passFailRate: 'Passing / Failing Rate',
    topPerformingStudents: 'Top Performing Students',
    monthlyStudentGrowth: 'Monthly Student Growth',
    completedVsUncompletedExams: 'Completed vs Uncompleted Exams',
    recentExams: 'Recent Exams',
    exportExamReport: 'Export Exam Report',
    averageExamGrades: 'Average Exam Grades',
    averageScoreOverTime: 'Average Score Over Time',
    exportStudentReport: 'Export Student Report',
    freePlan: 'Free Plan',
    certifiedTeacher: 'Certified Teacher',
    verifiedAndActive: 'Verified & Active',
    subscriptionEnd: 'Subscription End',
    noActiveSubscription: 'No active subscription',
    basicInformation: 'Basic Information',
    securityAndPrivacy: 'Security & Privacy',
    subscriptionPlan: 'Subscription Plan',
    profileSaveWarningHint: 'Your data will be updated immediately upon saving. Please ensure the information entered is correct.',
    protectYourAccount: 'Protect Your Account',
    passwordEncryptionNotice: 'Your password is encrypted and cannot be viewed by anyone. To change it, please enable edit mode.',
    newPassword: 'New Password',
    leaveBlankToKeepUnchanged: 'Leave blank to keep unchanged',
    passwordMinLengthLimit: 'Must be at least 6 characters',
    sidebarGeneral: 'General',
    sidebarAcademic: 'Academic Management',
    sidebarOperations: 'Operations Management',
    sidebarPlatform: 'Platform Management',
    sidebarGroups: 'Groups',
    sidebarToggleTooltip: 'Expand or collapse menu',
    noResultsForThisExam: 'No results found for this exam',
    errorLoadingResults: 'An error occurred while loading results',
    loadingExamResults: 'Loading exam results...',
    examMightBeNewOrNotSolved: 'The exam might be new or no one has solved it yet',
    goBack: 'Go Back',
    studentsResultsBoard: 'Students Results Board',
    viewDetailedStudentStats: 'View detailed statistics and student results',
    searchByName: 'Search by name...',
    found: 'Found',
    result: 'result',
    gradesUploadedFromFiles: 'Grades uploaded from files',
    completedFromSystem: 'Completed from system',
    timeLabel: 'Time: ',
    minute: 'minute',
    resultSource: 'Result Source: ',
    uploadedFromFilesByTeacher: 'Uploaded from files by teacher',
    fromSystemAfterStudentCompletion: 'From system after student completion',
    overallPerformance: 'Overall Performance',
    trySearchingWithOtherWords: 'Try searching with other words',
    notificationUpdateFailed: 'Failed to update notification status',
    markAllReadFailed: 'Failed to mark all notifications as read',
    closeNotifications: 'Close notifications',
    defaultUser: 'User',
    newNotification: 'New notification',
    notification: 'Notification',
    updating: 'Updating...',
    readStatus: 'Read',
    unreadStatus: 'Unread',
    loadingMoreNotifications: 'Loading more...',
    noMoreNotifications: 'No more notifications',
    notificationsTitle: 'Notifications',
    analysisGeneratedSuccess: 'Analysis generated successfully.',
    analysisSuccess: 'Performance analyzed successfully',
    analysisFetchError: 'No student data or error fetching analysis. Please try again later.',
    chatBotHelpMessage: 'Okay, I\'m here if you need any other help.',
    reportSentSuccess: 'Report sent to parent successfully',
    reportSentFailed: 'Failed to send report',
    reportSentError: 'Error occurred while sending report',
    loadingStudentData: 'Loading student data...',
    studentNotFoundTitle: 'Student not found',
    studentNotFoundMessage: 'The requested student does not exist or has been deleted',
    smartPerformanceAnalysisReport: 'Smart Performance Analysis Report',
    generatedByRafiqAI: 'Generated by Rafiq AI',
    sendReportToParentWhatsApp: 'Send report to parent (WhatsApp)',
    analyzeStudentPerformance: 'Analyze student performance',
    chatBotWelcomeTeacher: 'Welcome Mr. {teacherName}! Would you like a comprehensive analysis of student {studentName}\'s performance?',
    yesAnalyzePerformance: 'Yes, analyze performance',
    noThankYou: 'No, thank you',
    studentDataFetchFailed: 'Failed to load student data',
    cvm_videosLoadError: 'Failed to load course videos',
    cvm_atLeastOneVideoRequired: 'At least one video must be added',
    cvm_notSpecified: 'Not specified',
    cvm_videosAddedSuccess: 'Videos added successfully',
    cvm_videosAddError: 'An error occurred while adding videos',
    cvm_areYouSure: 'Are you sure?',
    cvm_cannotRestoreVideo: 'You will not be able to restore this video after deletion!',
    cvm_yesDelete: 'Yes, delete',
    cvm_videoDeletedSuccess: 'Video deleted successfully',
    cvm_videoDeleteError: 'Failed to delete video',
    cvm_backToCourses: 'Back to courses',
    cvm_manageVideos: 'Manage Videos',
    cvm_videosLibrary: 'Videos Library',
    cvm_uploadNewVideos: 'Upload New Videos',
    cvm_totalCourseVideosSize: 'Total course videos size',
    cvm_video: 'video',
    cvm_noVideosYet: 'No videos yet',
    cvm_enrichCourseContent: 'Start enriching your course and adding visual content for students',
    cvm_addNewVideo: 'Add new video',
    cvm_videoFromCourse: 'Video from course',
    cvm_addedRecently: 'Added recently',
    cvm_size: 'Size: ',
    cvm_dragToReorder: 'Drag to reorder',
    cvm_orderSavedSuccess: 'Order saved successfully',
    cvm_orderSaveFailed: 'Failed to save order',
    cvm_saveOrder: 'Save Order',
    cvm_manageQuestions: 'Manage questions',
    cvm_deleteVideo: 'Delete video',
    cvm_editVideoDescription: 'Edit video description',
    cvm_editVideoDescriptionTitle: 'Edit Video Description',
    cvm_updateDescriptionSuccess: 'Video description updated successfully',
    cvm_updateDescriptionError: 'Failed to update video description',
    cvm_videoTitleDescription: 'Video Title / Description',
    cvm_videoTitlePlaceholder: 'Example: Lesson 1 - Introduction to the subject',
    cvm_videoFile: 'Video file',
    cvm_dragOrClickVideo: 'Click or drag to choose a video',
    cvm_maxVideoSize: 'MP4, WebM (Max 500MB)',
    cvm_chooseVideo: 'Choose video',
    cvm_changeVideo: 'Change video',
    cvm_addAnotherVideo: 'Add another video',
    cvm_startUpload: 'Start upload',
    cvm_uploadingProgress: 'Uploading...',
    cvm_uploadHintTitle: 'Important Upload Note:',
    cvm_uploadLimitHint: 'To prevent server overload and high data load, it is recommended to upload a maximum of 3 videos at a time to ensure a successful upload process.',
    cvm_uploadMaxThreeRecommended: 'It is recommended to upload a maximum of 3 videos per batch for optimal server performance.',
    cvm_introVideoHintTitle: 'Note:',
    cvm_introVideoHint: 'The first video in the list will always be displayed as the introductory (Intro) video for the course.',
    cvm_updateVideoBtn: 'Update video file',
    cvm_updateVideoTitle: 'Update Video File',
    cvm_updateVideoFileLabel: 'New Video File',
    cvm_updateVideoFileSubText: 'Select the new video file to replace the current one (MP4, WebM - Max 500MB)',
    cvm_updateVideoSubmitBtn: 'Update Video',
    cvm_updatingVideoProgress: 'Updating...',
    cvm_updateVideoSuccess: 'Video file updated successfully',
    cvm_updateVideoError: 'Failed to update video file',
    softGrid_deleteSelectedBtn: 'Delete Selected',
    softGrid_confirmDeleteSelected: 'Are you sure you want to delete {count} selected items? This action cannot be undone.',
    softGrid_deleteSelectedSuccess: '{count} items deleted successfully',
    softGrid_deleteSelectedError: 'Failed to delete selected items',
    teacherDocumentation: 'Teacher Documentation',
    tv_customizeTemplate: 'Customize Template',
    tv_cancel: 'Cancel',
    tv_saveChanges: 'Save Changes',
    tv_enterValue: 'Enter',
    mz_aiStep1: 'Excellent. What is the grade level? (e.g., Third Secondary)',
    mz_aiStep2: 'How many slides do you want? (e.g., 10)',
    mz_aiErrCount1: 'Please enter a valid integer greater than zero.',
    mz_aiErrCount2: 'Sorry, the maximum number of slides is 10. Please enter a number from 1 to 10.',
    mz_aiStep3: 'What is your preferred language for the slides?',
    mz_aiLangAr: 'Arabic',
    mz_aiLangEn: 'English',
    mz_aiStep4: 'Do you have any additional notes? (You can type "None")',
    mz_aiStep5: 'All information gathered successfully. Do you want to customize the design (colors, fonts) or generate the presentation now?',
    mz_aiGenNow: 'Generate Presentation Now',
    mz_aiCustStyle: 'Customize Design',
    mz_aiProcessing: 'Processing...',
    mz_aiCustOpening: 'Opening design customization window... After finishing, click the button above to generate.',
    mz_aiGenSent: 'The request to generate the presentation has been sent.',
    mz_aiSuccess: 'Presentation generated successfully! Downloading...',
    mz_aiPathNotFound: 'File path not found in the response.',
    mz_aiFail: 'Failed to generate presentation.',
    mz_helperNoteEdit: 'Upload a new file to replace current attachments (Optional)',
    mz_helperNoteAdd: 'Upload attachments (Images, PDF, Word, Excel, PPT) - Required',
    mz_pdfWatermarkErr: 'All files must be in PDF format when watermark is enabled',
    mz_attachedFile: 'Attached file',
    mz_aiCreateBtnTitle: 'Create AI Presentation',
    mz_aiWelcomeMessage: 'Welcome to the Presentation Creator! What is the topic of the presentation you want?',
    mz_aiBetaHint: 'Beta Version',
    mz_aiOldFilesList: 'Here are your old files:',
    mz_aiOldFile: 'View file {count}',
    mz_aiNoOldFiles: 'There are no old files.',
    mz_aiOldFilesFail: 'Failed to fetch old files.',
    mz_aiGenSuccessAction: 'Presentation generated successfully! What would you like to do now?',
    mz_aiViewFile: 'View File',
    mz_aiDownloadFile: 'Download File',
    mz_aiOldFilesHint: 'Old files will be deleted after 7 days',
    mz_aiCreateNew: 'Create New Presentation',
    mz_aiViewOld: 'View Old Files',
    ds_noSteps: 'No steps to display',
    ds_failedSave: 'Failed to save step data',
    ds_unexpectedError: 'An unexpected error occurred',
    ds_submitSuccess: 'Submitted successfully',
    ds_submitFailed: 'Submission failed',
    ds_completedSuccess: 'Completed successfully',
    ds_processing: 'Processing...',
    ds_btnBack: 'Back',
    ds_btnSubmit: 'Submit',
    ds_btnNext: 'Next',
    pptx_topic: 'Presentation Topic',
    pptx_topicPlaceholder: 'e.g., Photosynthesis',
    pptx_grade: 'Grade Level',
    pptx_gradePlaceholder: 'e.g., 7th Grade',
    pptx_slidesCount: 'Number of Slides',
    pptx_lang: 'Language',
    pptx_langAr: 'Arabic',
    pptx_langEn: 'English',
    pptx_notes: 'Additional Notes (Optional)',
    pptx_notesPlaceholder: 'Any specific details you want included...',
    pptx_readyTitle: 'Ready to Generate!',
    pptx_readyDesc: 'Click submit to generate the PPTX file.',
    pptx_basicInfo: 'Basic Info',
    pptx_basicInfoDesc: 'Enter topic and grade level.',
    pptx_config: 'Configuration',
    pptx_configDesc: 'Slides count and language.',
    pptx_confirm: 'Confirm & Generate',
    pptx_confirmDesc: 'Add notes and generate PPTX.',
    pptx_enterTopic: 'Please enter a topic',
    pptx_genSuccess: 'Presentation generated successfully!',
    pptx_readyHeader: 'Your presentation is ready!',
    pptx_btnView: 'View Online',
    pptx_btnDownload: 'Download PPTX',
    pptx_btnAnother: 'Generate Another',
    pptx_title: 'Generate AI Presentation',
    pptx_subtitle: 'Follow the steps to generate your customized PowerPoint lesson.',
    // Course Video Manager & Quizzes
    cvm_reorderHintTitle: 'Reordering Videos:',
    cvm_reorderHintDesc: 'You can easily reorder videos for students by dragging and dropping them into your preferred position, then clicking "Save Order".',
    cvm_explanationLabel: 'Explanation (Clarification)',
    cvm_timestampLabel: 'Question appearance time (in seconds)',
    cvm_timestampLabelMinutes: 'Question appearance time (in minutes)',
    cvm_scoreLabel: 'Score',
    cvm_choiceLabel: 'Option',
    cvm_isChoiceCorrect: 'Is option {n} correct?',
    cvm_correctOption: 'Correct',
    cvm_incorrectOption: 'Incorrect',
    cvm_addNewQuestionBtn: 'Add new question to video',
    cvm_viewManageQuizzes: 'View & manage video quizzes',
    cvm_addNewQuestionTitle: 'Add New Question',
    cvm_videoQuizQuestions: 'Video Quiz Questions',
    cvm_uniqueChoiceValidation: 'Options must be unique',
    cvq_loadingQuestions: 'Loading questions...',
    cvq_duplicateOptionError: 'Duplicate options are not allowed.',
    cvq_addQuestionSuccess: 'Question added successfully',
    cvq_updateQuestionSuccess: 'Question updated successfully',
    cvq_deleteQuestionConfirmTitle: 'Confirm Delete Question',
    cvq_deleteQuestionConfirmMessage: 'Are you sure you want to delete this question?',
    cvm_confirmDeleteVideoTitle: 'Confirm Delete Video',
    cvm_confirmDeleteVideoMessage: 'Are you sure you want to delete this video? All associated quiz questions and attached files will be permanently deleted, and students will lose access to them.',
    cva_addAttachmentBtn: 'Add attachment to video',
    cva_addAttachmentTitle: 'Add New Attachment',
    cva_attachmentTitleLabel: 'Attachment Title',
    cva_attachmentDescLabel: 'Attachment Description (Optional)',
    cva_attachmentFileLabel: 'Attachment File',
    cva_fileSubText: 'Select attachment file (PDF, DOCX, Images, etc.)',
    cva_addAttachmentSuccess: 'Attachment added successfully',
    cva_addAttachmentError: 'Failed to add attachment',
    cva_viewAttachmentsBtn: 'View & manage video attachments',
    cva_videoAttachmentsTitle: 'Video Attachments',
    cva_noAttachmentsYet: 'No attachments added to this video yet',
    cva_addAttachmentHint: 'You can add attached files, documents, and images using the Add Attachment button on the video card.',
    cva_editAttachmentTitle: 'Edit Attachment Details',
    cva_deleteAttachmentConfirmTitle: 'Confirm Delete Attachment',
    cva_deleteAttachmentConfirmMessage: 'Are you sure you want to delete this attachment permanently?',
    cva_updateSuccess: 'Attachment updated successfully',
    cva_updateError: 'Failed to update attachment details',
    cva_deleteSuccess: 'Attachment deleted successfully',
    cva_deleteError: 'Failed to delete attachment',
    cva_downloadFile: 'Open / Download File',
    cva_titleLabel: 'Attachment Title',
    cva_descLabel: 'Description',
    cvm_searchPlaceholder: 'Search video by title or description...',
    cvm_noSearchResults: 'No videos match your search query',
    limitWarning: 'Warning: You are approaching the maximum limit ',
    forStorageAndStudents: 'for storage and students.',
    forStorage: 'for storage.',
    forStudents: 'for students.',
    limitWarningforStorage: 'for storage.',
    upgradeNow: 'Upgrade now',
    totalUserCoursesCapacityInMB: 'Total Capacity'
  },
  ar: {
    // AddEditExamDetails
    examDetailsQuestionRequired: 'يجب إدخال نص السؤال',
    examDetailsOptionRequired: 'لا يمكن ترك خيار فارغ',
    examDetailsFourOptions: 'يجب أن يكون هناك 4 خيارات',
    examDetailsUniqueOptions: 'يجب أن تكون جميع الخيارات مختلفة',
    examDetailsCorrectAnswerRequired: 'يجب اختيار الإجابة الصحيحة',
    examDetailsCannotDeleteLast: 'لا يمكن حذف السؤال الأخير',
    examDetailsDeleteQuestionConfirm: 'هل أنت متأكد أنك تريد حذف هذا السؤال؟',
    examDetailsYesDelete: 'نعم، احذف',
    examDetailsSaveQuestionsFail: 'فشل في حفظ الأسئلة',
    examDetailsAtLeastOneQuestion: 'يجب إضافة سؤال واحد على الأقل',
    examDetailsQuestionErrorPrefix: 'س{index}: ',
    examDetailsSaveQuestionsSuccess: 'تم حفظ الأسئلة بنجاح',
    examDetailsSelectQuestionsToDelete: 'الرجاء اختيار الأسئلة المراد حذفها',
    examDetailsDeleteSelectedConfirm: 'هل أنت متأكد أنك تريد حذف الأسئلة المحددة؟',
    examDetailsDeleteSelectedSuccess: 'تم حذف الأسئلة بنجاح',
    examDetailsInvalidFile: 'يرجى اختيار ملف مدعوم (DOCX, PDF, الصور)',
    examDetailsFileSizeLimit: 'حجم الملف يجب أن يكون أقل من 20 ميجابايت',
    examDetailsAiUploadSuccess: 'تم رفع الأسئلة باستخدام الذكاء الاصطناعي بنجاح',
    examDetailsAiUploadFail: 'فشل في رفع الأسئلة باستخدام الذكاء الاصطناعي',
    examDetailsNoteSaveSuccess: 'تم حفظ الأسئلة من المذكرة بنجاح',
    examDetailsAutoGenerateSaveFail: 'فشل في حفظ الأسئلة المولدة تلقائياً',
    examDetailsNoteExtractSuccess: 'تم استخراج {count} سؤال من مذكراتك بنجاح! جاري حفظ الأسئلة...',
    examDetailsNoteNoQuestions: 'لم يتم العثور على مذكرات مناسبة أو فشل استخراج الأسئلة.',
    examDetailsNoteExtractFail: 'فشل في استخراج الأسئلة من المذكرة',
    examDetailsNoteExtractError: 'حدث خطأ أثناء استخراج الأسئلة. يرجى التأكد من وجود مذكرات كافية.',
    examDetailsHowManyQuestions: 'كم عدد الأسئلة التي تريد إنشاءها؟',
    examDetailsNQuestions: '{n} أسئلة',
    examDetailsManualFallback: 'حسناً، يمكنك إضافة الأسئلة يدوياً أو استخدام رفع الملفات.',
    examDetailsInvalidQuestionCount: 'يرجى اختيار عدد بين 1 و 100 سؤال.',
    examDetailsGeneratedSaveSuccess: 'تم حفظ الأسئلة المولدة بنجاح',
    examDetailsGeneratedCreateSuccess: 'تم إنشاء {count} سؤال بنجاح! جاري حفظ الأسئلة...',
    examDetailsGeneratedCreateFail: 'لم يتم إنشاء أي أسئلة. يرجى المحاولة مرة أخرى.',
    examDetailsGenerateFail: 'فشل في إنشاء الأسئلة',
    examDetailsGenerateError: 'حدث خطأ أثناء إنشاء الأسئلة. يرجى المحاولة مرة أخرى.',
    examDetailsDeleteImageFail: 'فشل في حذف الصورة من الخادم',
    examDetailsTeacherFallback: 'الأستاذ',
    examDetailsNotFound: 'لم يتم العثور على بيانات الاختبار',
    examDetailsWelcomeMessage: 'مرحبا استاذ {name}! هل تود بانشاء اسئلة لهذا الامتحان؟',
    examDetailsCreateFromNote: 'إنشاء من مذكرة',
    examDetailsPageTitle: 'إدارة أسئلة الاختبار',
    examDetailsBack: 'العودة',
    examDetailsMinutes: '{duration} دقيقة',
    examDetailsRandomOrder: 'ترتيب عشوائي',
    examDetailsManualOrder: 'ترتيب يدوي',
    examDetailsAiUploadLoading: 'جاري الرفع...',
    examDetailsAiUploadPlaceholder: 'رفع اسئلة باستخدام رفيق المساعد',
    examDetailsAiUploadSubtext: 'يدعم الملفات: DOCX, PDF, الصور - الحد الأقصى: 20 ميجابايت',
    examDetailsAiUploadButtonLoading: 'جاري الرفع',
    examDetailsAiUploadButton: 'اختيار ملف',
    examDetailsAiWarning: 'تحذير: يمكن لرفيق أن يولد أسئلة بها نسبة بسيطة من الخطأ برجاء المراجعة',
    examDetailsDeselectAll: 'إلغاء تحديد الكل',
    examDetailsSelectAll: 'تحديد الكل',
    examDetailsQuestionsManage: 'إدارة الأسئلة ({count} سؤال)',
    examDetailsQuestionsRandomNote: 'الأسئلة ستظهر بترتيب عشوائي للطلاب',
    examDetailsSaveOrder: 'حفظ الترتيب',
    examDetailsDeleteQuestions: 'حذف الأسئلة',
    examDetailsSaveAll: 'حفظ جميع الأسئلة',
    examDetailsQuestionN: 'السؤال {n}',
    examDetailsQuestionTextPlaceholder: 'اكتب نص السؤال هنا...',
    examDetailsQuestionImage: 'صورة السؤال (اختياري)',
    examDetailsUploadImagePlaceholder: 'رفع صورة للسؤال',
    examDetailsUploadImageSubtext: 'اسحب وأفلت الصورة هنا أو اضغط للاختيار',
    examDetailsUploadImageButton: 'اختيار صورة',
    examDetailsOptionPlaceholder: 'الخيار {letter}',
    examDetailsNoQuestionText: 'لا يوجد نص للسؤال',
    examDetailsConfirmDeleteImage: 'تأكيد حذف الصورة',
    examDetailsConfirmDeleteImageText: 'هل أنت متأكد أنك تريد حذف هذه الصورة نهائياً من السؤال؟',
    examDetailsCancel: 'تراجع',
    examDetailsRafeeqAssistant: 'رفيق المساعد',
    examDetailsUpdateOrderSuccess: 'تم تحديث ترتيب الأسئلة بنجاح',
    examDetailsUpdateOrderFail: 'فشل في تحديث ترتيب الأسئلة',
    examDetailsDeleteImageSuccess: 'تم حذف الصورة بنجاح',
    examDetailsLoadingData: 'جاري تحميل تفاصيل الاختبار...',
    examDetailsSaving: 'جاري الحفظ...',
    examDetailsQuestionTextLabel: 'نص السؤال',
    examDetailsChangeImage: 'تغيير الصورة',
    examDetailsDeleteImageBtn: 'حذف الصورة',
    examDetailsDeleteImageConfirmBtn: 'حذف الصورة',
    examDetailsAddQuestion: 'إضافة سؤال',
    examDetailsScratchpad: 'المسودة',

    // Alerts
    confirmDeleteTitle: 'تأكيد الحذف',
    confirmDeleteText: 'هل أنت متأكد من حذف هذا العنصر؟',
    cannotUndoAction: 'لا يمكن التراجع عن هذا الإجراء',
    deleteBtn: 'حذف',
    warningTitle: 'تحذير',
    warningText: 'هل أنت متأكد من الاستمرار؟',
    warningAttention: 'يرجى الانتباه قبل المتابعة',
    continueBtn: 'متابعة',

    // ExamManager Remaining
    examLoadError: 'حدث خطأ أثناء تحميل الاختبارات',
    examUpdateError: 'فشل في تحديث الاختبار',
    examUpdateSuccess: 'تم تحديث الاختبار بنجاح',
    examAddError: 'فشل في إضافة الاختبار',
    examAddSuccess: 'تم إضافة الاختبار بنجاح',
    examSaveError: 'حدث خطأ أثناء حفظ بيانات الاختبار',
    useScratchpad: 'استخدام المسودة',
    examHoursFormat: '{hours}:{minutes} ساعة',
    examStartConfirmTitle: 'تأكيد بدء الامتحان',
    examStartConfirmText: 'هل أنت متأكد من بدء الامتحان "{title}"؟',
    examStartConfirmYes: 'نعم، ابدأ الامتحان',
    examStartSuccess: 'تم بدء الامتحان بنجاح',
    examResetConfirmTitle: 'هل أنت متأكد؟',
    examResetConfirmText: 'سيتم إعادة تعيين الامتحان ومحو جميع درحات الطلاب السابقة الخاصة بهذا الامتحان، ولن يمكنك التراجع عن هذا الإجراء!',
    examResetConfirmYes: 'نعم، إعادة التعيين',
    examResetSuccess: 'تم إعادة تعيين الامتحان بنجاح',
    examResetError: 'فشل في إعادة تعيين الامتحان',
    examStopConfirmTitle: 'تأكيد إيقاف الامتحان',
    examStopConfirmText: 'هل أنت متأكد من إيقاف الامتحان "{title}"؟',
    examStopConfirmYes: 'نعم، أوقف الامتحان',
    examStopSuccess: 'تم إيقاف الامتحان بنجاح',
    examStopError: 'فشل في إيقاف الامتحان',
    examSendResultsConfirmTitle: 'تأكيد إرسال النتائج',
    examSendResultsConfirmText: 'هل أنت متأكد من إرسال نتائج الامتحان "{title}" للآباء؟',
    examSendResultsConfirmYes: 'نعم، أرسل النتائج',
    examSendResultsSuccess: 'تم إرسال نتائج الاختبار للآباء بنجاح',
    examSendResultsError: 'فشل في إرسال نتائج الاختبار للآباء',
    examDeleteSuccess: 'تم حذف الامتحان بنجاح',
    examDeleteError: 'حدث خطأ أثناء حذف الامتحان',
    examPrintNoQuestions: 'لا توجد أسئلة الامتحان للطباعة',
    examPrintFetchError: 'حدث خطأ أثناء جلب أسئلة الامتحان',
    examAssignConfirmTitle: 'تأكيد تعيين الطالب',
    examAssignConfirmText: 'هل أنت متأكد من تعيين الطالب المحدد للاختبار "{title}"؟',
    examAssignConfirmYes: 'نعم، عين الطالب',
    examAssignSuccess: 'تم تعيين الطالب للاختبار بنجاح',
    examAssignError: 'فشل في تعيين الطالب للاختبار',
    dataLoadError: 'حدث خطأ أثناء تحميل البيانات',
    examStarting: 'جاري بدء الامتحان...',
    examStopping: 'جاري إيقاف الامتحان...',
    examSendingResults: 'جاري إرسال النتائج للآباء...',
    examPrinting: 'جاري إعداد الامتحان للطباعة...',
    examLoadingExams: 'جاري تحميل الاختبارات...',
    examResetting: 'جاري إعادة تعيين الاختبار...',
    examUpcoming: 'قادم',
    examInProgress: 'قيد التنفيذ',
    examDeleteConfirmTitle: 'تأكيد حذف الامتحان',
    examDeleteConfirmText: 'هل أنت متأكد من حذف هذا الامتحان؟',
    examDatePrefix: 'تاريخ الامتحان: ',
    examAssignStudentLabel: 'تعيين طالب للاختبار: ',
    examAssigning: 'جاري التعيين...',
    examAssignBtn: 'تعيين',
    examInProgressModalTitle: 'تفاصيل الامتحان قيد التنفيذ',
    examCloseBtn: 'إغلاق',
    examSubjectLabel: 'المادة: ',
    examClassLabel: 'الصف: ',
    examStatusLabel: 'الحالة: ',
    examPassedStudents: 'الطلاب الذين اجتازوا الامتحان:',
    examNoPassedStudents: 'لا يوجد طلاب اجتازوا هذا الامتحان بعد.',
    examTestTitleLabel: 'عنوان الاختبار: ',
    examRetakeBtn: 'إعادة الامتحان',
    examRetakeConfirmTitle: 'تأكيد إعادة الامتحان',
    examRetakeConfirmText: 'هل أنت متأكد أنك تريد إعادة الامتحان للطالب {name}؟',
    examRetakeConfirmYes: 'نعم، إعادة',
    examRetakeSuccess: 'تم إعادة الامتحان للطالب {name}',
    examRetakeError: 'فشل في إعادة الامتحان للطالب',
    examResetSessionBtn: 'تصفير جلسة الامتحان',
    examResetSessionConfirmTitle: 'تأكيد تصفير الجلسة',
    examResetSessionConfirmText: 'هل أنت متأكد أنك تريد تصفير جلسة الامتحان للطالب {name}؟',
    examResetSessionConfirmYes: 'نعم، تصفير',
    examResetSessionSuccess: 'تم تصفير جلسة الامتحان للطالب {name}',
    examResetSessionError: 'فشل في تصفير الجلسة للطالب',
    examNotCompletedStudentsTitle: 'الطلاب غير المنتهين للاختبار: {title}',
    examNotCompletedStudentsFallback: 'الطلاب غير المنتهين',
    examNoNotCompletedStudents: 'لا يوجد طلاب لم يكملوا هذا الاختبار.',

    // Dynamic Modal validation and UI
    invalidEmail: 'البريد الإلكتروني غير صالح',
    mustBeNumeric: 'يجب أن تكون قيمة رقمية',
    minimumIs: 'الحد الأدنى هو',
    maximumIs: 'الحد الأقصى هو',
    invalidUrl: 'الرابط غير صالح',
    invalidPhoneNumber: 'رقم الهاتف غير صالح',
    minChars: 'الحد الأدنى أحرف:',
    maxChars: 'الحد الأقصى أحرف:',
    invalidFormat: 'الصيغة غير صحيحة',
    requiredField: 'مطلوب',
    loadingOptions: 'جاري التحميل...',
    searchPlaceholder: 'ابحث...',
    noResultsFound: 'لا توجد نتائج',
    dragAndDropFile: 'اسحب وأفلت الملف هنا أو اضغط للاختيار',
    changeFile: 'تغيير الملف',
    sendingData: 'جاري الإرسال...',

    paidStatus: 'مدفوع',
    unpaidStatus: 'غير مدفوع',
    pendingStatus: 'قيد الانتظار',
    courseLabel: 'الدورة',
    studentLabel: 'الطالب',
    paymentStatusLabel: 'حالة الدفع',
    subscriptionLoadError: 'حدث خطأ أثناء تحميل الاشتراكات',
    subscriptionDeleteSuccess: 'تم حذف الاشتراك بنجاح',
    subscriptionDeleteError: 'حدث خطأ أثناء حذف الاشتراك',
    subscriptionUpdateSuccess: 'تم تحديث الاشتراك بنجاح',
    subscriptionAddSuccess: 'تم إضافة الاشتراك بنجاح',
    subscriptionSaveError: 'حدث خطأ أثناء حفظ الاشتراك',
    deletingSubscription: 'جاري حذف الاشتراك...',
    savingSubscription: 'جاري حفظ الاشتراك...',
    loadingSubscriptions: 'جاري تحميل الاشتراكات...',
    courseSubscriptionsTitle: 'إدارة اشتراكات الدورات',
    addNewSubscription: 'إضافة اشتراك جديد',
    editSubscription: 'تعديل الاشتراك',
    addSubscriptionBtn: 'إضافة اشتراك',
    updateSubscriptionBtn: 'تحديث الاشتراك',
    confirmDeleteSubscriptionTitle: 'تأكيد حذف الاشتراك',
    confirmDeleteSubscriptionMessage: 'هل أنت متأكد من حذف هذا الاشتراك؟ سيفقد الطالب إمكانية الوصول إلى الدورة نهائياً.',
    noSubscriptionsAvailable: 'لا توجد اشتراكات متاحة',
    searchSubscriptionPlaceholder: 'ابحث عن اشتراك...',
    coursePrefix: 'الدورة: ',
    studentViewPreview: "معاينة الطالب",
    websitePreview: "معاينة الموقع",
    livePreviewSubtitle: "معاينة مباشرة - للعرض فقط",
    courseRequestsLoadError: 'حدث خطأ أثناء تحميل طلبات التسجيل',
    confirmRequestTitle: 'تأكيد الطلب',
    confirmRequestMessage: 'إذا تم التأكيد، سيتم تسجيل الطالب في هذه الدورة وسيحصل على حق الوصول الكامل لمحتواها.',
    confirmYesBtn: 'نعم، تأكيد',
    addNoteTitle: 'إضافة ملاحظة',
    noteLabelOptional: 'ملاحظة (اختياري)',
    notePlaceholder: 'اكتب ملاحظتك هنا...',
    requestConfirmSuccess: 'تم تأكيد الطلب بنجاح',
    requestConfirmError: 'حدث خطأ أثناء تأكيد الطلب',
    rejectRequestTitle: 'رفض الطلب',
    rejectReasonLabel: 'سبب الرفض',
    rejectReasonPlaceholder: 'اكتب سبب الرفض هنا...',
    rejectBtn: 'رفض',
    rejectReasonRequired: 'سبب الرفض مطلوب',
    requestRejectSuccess: 'تم رفض الطلب بنجاح',
    requestRejectError: 'حدث خطأ أثناء رفض الطلب',
    requestDeleteSuccess: 'تم حذف الطلب بنجاح',
    requestDeleteError: 'حدث خطأ أثناء حذف الطلب',
    statusPending: 'قيد الانتظار',
    statusRejected: 'مرفوض',
    statusConfirmed: 'مؤكد',
    statusUnknown: 'غير معروف',
    deletingRequest: 'جاري حذف الطلب...',
    loadingRequests: 'جاري تحميل الطلبات...',
    courseRequestsTitle: 'طلبات الاشتراك في الدورات',
    rejectTooltip: 'رفض',
    searchRequestPlaceholder: 'ابحث عن طلب...',
    confirmDeleteRequestTitle: 'تأكيد حذف الطلب',
    confirmDeleteRequestMessage: 'هل أنت متأكد من حذف هذا الطلب؟',
    failedToLoadCourses: 'فشل في تحميل الدورات',
    failedToLoadCourseDetails: 'فشل في تحميل تفاصيل الدورة',
    courseDeletedSuccess: 'تم حذف الدورة بنجاح',
    courseDeleteFailed: 'حدث خطأ أثناء حذف الدورة',
    courseHoursRecalculated: 'تم إعادة حساب ساعات الدورة بنجاح',
    courseHoursRecalculateFailed: 'فشل في إعادة حساب ساعات الدورة',
    courseHoursRecalculateError: 'حدث خطأ أثناء إعادة حساب ساعات الدورة',
    courseVisibilityChanged: 'تم تغيير ظهور الدورة بنجاح',
    courseVisibilityChangeFailed: 'فشل في تغيير ظهور الدورة',
    courseVisibilityChangeError: 'حدث خطأ أثناء تغيير ظهور الدورة',
    courseNameRequired: 'اسم الدورة مطلوب',
    courseDescriptionRequired: 'وصف الدورة مطلوب',
    coursePriceRequired: 'السعر مطلوب',
    courseDiscountValue: 'قيمة الخصم',
    courseCategory: 'التصنيف',
    courseCategoryRequired: 'التصنيف مطلوب',
    courseCouponOptional: 'كوبون الخصم (اختياري)',
    courseIsCertified: 'هل الدورة معتمدة؟',
    courseImage: 'صورة الدورة',
    courseUpdatedSuccess: 'تم تحديث الدورة بنجاح',
    courseAddedSuccess: 'تم إضافة الدورة بنجاح',
    courseManagementTitle: 'إدارة الدورات',
    courseManagementSubtitle: 'إدارة وتنظيم تفاصيل الدورات التعليمية',
    subscriptionsTab: 'الاشتراكات',
    registrationRequestsTab: 'طلبات التسجيل',
    loadingCourses: 'جاري تحميل الدورات...',
    noCoursesYet: 'لا توجد دورات بعد',
    addYourFirstCourse: 'أضف دورتك التعليمية الأولى',
    showCourse: 'إظهار الدورة',
    hideCourse: 'إخفاء الدورة',
    certified: 'معتمدة',
    notCertified: 'غير معتمدة',
    calculating: 'جاري الحساب...',
    recalculateHours: 'إعادة حساب الساعات',
    confirmDeleteCourseTitle: 'تأكيد حذف الدورة',
    confirmDeleteCourseMessage: 'هل أنت متأكد من حذف هذه الدورة؟',
    materialLabelPrefix: 'المادة: ',
    createNewCourseTitle: 'إنشاء دورة جديدة',
    createCourseBtn: 'إنشاء الدورة',
    courseSaveError: 'حدث خطأ أثناء حفظ الدورة',
    examTitleMinLength: 'يجب أن يكون عنوان الاختبار 5 أحرف على الأقل',
    examDurationInMinutes: 'مدة الاختبار (بالدقائق)',
    durationInMinutes: 'المدة (بالدقائق)',
    examDurationMin: 'مدة الاختبار يجب أن تكون أكبر من 0',
    questionWeightRequired: 'وزن السؤال مطلوب',
    questionWeightMin: 'وزن السؤال يجب أن يكون 0.01 على الأقل',
    normalOrder: 'ترتيب عادي',
    randomOrder: 'ترتيب عشوائي',
    examDescriptionOptional: 'وصف الاختبار (اختياري)',
    addNewExamTitle: 'إضافة اختبار جديد',
    editExamTitle: 'تعديل تفاصيل الاختبار',
    createExamBtn: 'إنشاء اختبار',
    updateExamBtn: 'تحديث الاختبار',
    examIdLabel: 'رمز الاختبار',
    questionsCountLabel: 'عدد الأسئلة',
    statusLabel: 'الحالة',
    searchExamPlaceholder: 'البحث عن اختبار...',
    noExamsAvailable: 'لا توجد اختبارات متاحة',
    stopExamTooltip: 'إيقاف الاختبار',
    sendToParentsTooltip: 'إرسال لأولياء الأمور',
    examResultsTooltip: 'نتائج الاختبار',
    viewQuestionsTooltip: 'عرض الأسئلة',
    printExamTooltip: 'طباعة الاختبار',
    assignStudentTooltip: 'تعيين طالب',
    examQuestionsTooltip: 'أسئلة الاختبار',
    startExamTooltip: 'بدء الاختبار',
    viewUnfinishedStudentsTooltip: 'عرض الطلاب غير المكتملين',

    actionText: 'إجراء',
    recordText: 'سجل',
    recordActionsLabel: 'إجراءات السجل',
    selectedLabel: 'المحدد',
    activeColumnsLabel: 'الأعمدة النشطة',
    currentlyDisplayedLabel: 'المعروض حالياً',
    recordCountLabel: 'عدد السجلات',
    pageSizeLabel: 'حجم الصفحة:',
    selectAll: 'اختيار الكل',
    resetAction: 'اعادة تعيين',
    customizeColumns: 'تخصيص الاعمدة',
    columnsText: 'الاعمدة',
    rightClickForActions: 'انقر بزر الفأرة الأيمن لعرض الإجراءات',
    searchInAllColumns: 'ابحث في جميع الأعمدة...',
    noResultsAtThisTime: 'لا يوجد نتائج متاحة في هذا الوقت.',
    tryModifyingSearch: 'حاول تعديل بحثك أو استخدام الفلتر للعثور على ما تبحث عنه.',
    noDataAvailable: 'لا يوجد بيانات متاحة',
    noResultsSpace: ' لا يوجد نتائج',
    noResults: 'لا يوجد نتائج',
    search: 'بحث',
    groupBy: 'تجميع حسب',
    noGrouping: 'بدون تجميع',
    groupItemsCount: '{count} عنصر',
    examUseScratchpad: 'المسودة',
    examUseScratchpadLabel: 'تفعيل المسودة',
    examUseScratchpadDescription: 'السماح للطلاب باستخدام مسودة أثناء الاختبار',
    resetSession: 'إعادة تعيين الجلسة',
    confirmResetSession: 'هل أنت متأكد من أنك تريد إعادة تعيين الجلسة لهذا الطالب؟',
    failedToResetSession: 'فشل في إعادة تعيين الجلسة',
    reset: 'إعادة تعيين',
    mozakaraManagement: 'إدارة المذاكرة',
    mozakaraManagementDesc: 'أضف ونظّم وعدّل المذكرات والمواد الدراسية',
    addMozakara: 'إضافة مذكرة جديدة',
    mozakaraTitle: 'عنوان المذكرة',
    grade: 'الصف الدراسي',
    attachments: 'المرفقات',
    createdDate: 'تاريخ الإنشاء',
    noMozakara: 'لا توجد مذاكرة بعد. ابدأ بإضافة مذكرة جديدة.',
    searchMozakara: 'ابحث في المذاكرة...',
    mozakaraDeleteConfirmTitle: 'حذف مذكرة',
    mozakaraDeleteConfirmMessage: 'هل أنت متأكد من حذف هذه المذكرة؟ لا يمكن التراجع عن هذا الإجراء.',
    files: 'ملفات',
    noFiles: 'لا يوجد',
    untitled: 'بدون عنوان',
    mozakaraLoadFailed: 'فشل في تحميل المذاكرة',
    mozakaraDeleteSuccess: 'تم حذف المذكرة بنجاح',
    mozakaraDeleteFailed: 'فشل في حذف المذكرة',
    addEditMozakaraBack: 'رجوع',
    addEditMozakaraTitleAdd: 'إضافة مذكرة جديدة',
    addEditMozakaraTitleEdit: 'تعديل المذكرة',
    addEditMozakaraSubtitleAdd: 'املأ البيانات لإنشاء مذكرة جديدة لطلابك',
    addEditMozakaraSubtitleEdit: 'قم بتعديل بيانات المذكرة وإدارة المرفقات',
    addEditMozakaraInfoSection: 'معلومات المذكرة',
    addEditMozakaraTitleLabel: 'عنوان المذكرة',
    addEditMozakaraTitlePlaceholder: 'مثال: مذكرة اللغة العربية - الترم الأول',
    addEditMozakaraClassLabel: 'الصف الدراسي',
    addEditMozakaraClassPlaceholder: 'اختر الصف الدراسي',
    addEditMozakaraDescriptionLabel: 'الوصف',
    addEditMozakaraDescriptionPlaceholder: 'اكتب وصفاً قصيراً لمحتوى المذكرة...',
    addEditMozakaraCurrentAttachments: 'المرفقات الحالية',
    addEditMozakaraChooseFile: 'اختر ملف',
    addEditMozakaraChangeFile: 'تغيير الملف',
    addEditMozakaraAddSlot: 'إضافة خانة ملف أخرى',
    addEditMozakaraRemoveSlot: 'حذف الخانة',
    addEditMozakaraNoFile: 'لا يوجد ملف',
    addEditMozakaraCreating: 'جاري الإنشاء...',
    addEditMozakaraUpdating: 'جاري التحديث...',
    addEditMozakaraRequiredFields: 'يرجى ملء الحقول المطلوبة',
    addEditMozakaraRequiredAttachment: 'يرجى إضافة مرفق واحد على الأقل عند إنشاء مذكرة',
    addEditMozakaraInvalidFileType: 'نوع الملف غير مسموح به. الأنواع المسموحة: jpg, png, pdf, doc, xls, ppt',
    addEditMozakaraMaxSizeError: 'الملف يتجاوز الحد الأقصى (100 ميجابايت)',
    addEditMozakaraDeleteAttachmentTitle: 'حذف المرفق',
    addEditMozakaraDeleteAttachmentMessage: 'هل أنت متأكد من حذف هذا المرفق نهائياً؟',
    addEditMozakaraDeleteAttachmentSuccess: 'تم حذف المرفق بنجاح',
    addEditMozakaraDeleteAttachmentFailed: 'فشل في حذف المرفق',
    addEditMozakaraOpenAttachmentFailed: 'تعذر فتح المرفق',
    addEditMozakaraInvalidAttachmentLink: 'رابط المرفق غير متاح',
    addEditMozakaraCreateSuccess: 'تمت إضافة المذكرة بنجاح',
    addEditMozakaraUpdateSuccess: 'تم تحديث المذكرة بنجاح',
    addEditMozakaraSaveFailed: 'حدث خطأ أثناء الحفظ',
    addEditMozakaraLoadFailed: 'فشل في تحميل البيانات',
    addEditMozakaraFileSlot: 'المرفق',
    addEditMozakaraUploadingHint: 'الأنواع المسموحة: صور، PDF، Word، Excel، PPT - الحد الأقصى 100MB',
    addEditMozakaraAttachmentFallback: 'مرفق',
    welcome: 'مرحباً',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    dashboard: 'لوحة التحكم',
    exams: 'الاختبارات',
    students: 'الطلاب',
    reports: 'التقارير',
    blog: 'المدونة',
    profile: 'الملف الشخصي',
    settings: 'الإعدادات',
    activeExams: 'الاختبارات النشطة',
    studentCount: 'عدد الطلاب',
    averageScore: 'متوسط الدرجات',
    subscription: 'الاشتراك',
    remainingDays: 'المدة المتبقية',
    subscriptionDate: 'تاريخ الاشتراك',
    confirmDelete: 'تأكيد الحذف',
    expirationDate: 'تاريخ الانتهاء',
    lastExam: 'آخر اختبار',
    lastCompletedExam: 'آخر اختبار مكتمل',
    noRecentExams: 'لا يوجد اختبارات حديثة',
    noCompletedExams: 'لا يوجد اختبارات مكتملة',
    features: 'الميزات',
    enabled: 'مفعل',
    disabled: 'غير مفعل',
    activity: 'النشاط الأخير',
    searchBlogs: 'ابحث في المدونات...',
    addBlog: 'إضافة مدونة',
    editBlog: 'تعديل المدونة',
    create: 'إنشاء',
    update: 'تحديث',
    blogTitle: 'عنوان المدونة',
    description: 'وصف المدونة',
    content: 'محتوى المدونة',
    backToList: 'العودة للقائمة',
    category: 'الفئة',
    selectCategory: 'اختر الفئة',
    delete: 'حذف',
    cancel: 'إلغاء',
    confirmDeleteBlog: 'هل أنت متأكد من حذف هذه المدونة؟',
    noBlogs: 'لا توجد مدونات',
    addImage: 'اضغط لإضافة صورة',
    loading: 'جاري التحميل...',
    blogTitleRequired: 'عنوان المدونة مطلوب',
    blogDescriptionRequired: 'وصف المدونة مطلوب',
    blogContentRequired: 'محتوى المدونة مطلوب',
    blogCategoryRequired: 'فئة المدونة مطلوبة',
    categoryRequired: 'الفئة مطلوبة',
    titleRequired: 'العنوان مطلوب',
    descriptionRequired: 'الوصف مطلوب',
    contentRequired: 'المحتوى مطلوب',
    appName: 'منصة امتحاني',
    daysRemaining: 'يوم متبقي',
    logout: 'تسجيل الخروج',
    id: 'الرقم المسلسل',
    blogs: 'المدونات',
    reportsAndStatistics: 'تقارير وإحصائيات',
    downloadReport: 'تحميل التقرير',
    totalExams: 'إجمالي الاختبارات',
    totalStudents: 'إجمالي الطلاب',
    completionRate: 'نسبة الإكمال',
    examReports: 'تقارير الاختبارات',
    studentReports: 'تقارير الطلاب',
    searchExams: 'البحث في الاختبارات...',
    searchStudents: 'البحث عن طالب...',
    examName: 'اسم الاختبار',
    date: 'التاريخ',
    passingRate: 'نسبة النجاح',
    studentName: 'اسم الطالب',
    examsTaken: 'عدد الاختبارات',
    sendToParents: 'إرسال إلى الوالدين',
    sendingToParents: 'جاري إرسال إلى الوالدين...',
    lastExamDate: 'آخر اختبار',
    improvement: 'نسبة التحسن',
    notifications: 'الإشعارات',
    notificationError: 'حدث خطأ أثناء جلب الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    markAllAsRead: 'تعيين الكل كمقروء',
    refreshing: 'جاري التحديث...',
    forbiddenTitle: 'غير مصرح بالوصول',
    forbiddenDefaultMessage: 'غير مصرح لك بالوصول إلى هذه الصفحة.',
    welcomeBack: 'مرحباً بعودتك!',
    signInToContinue: 'سجّل الدخول للمتابعة',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    male: 'ذكر',
    female: 'أنثى',
    enterUsername: 'أدخل اسم المستخدم',
    enterPassword: 'أدخل كلمة المرور',
    show: 'إظهار',
    hide: 'إخفاء',
    sort: 'ترتيب',
    signIn: 'تسجيل الدخول',
    emailOrPhone: 'البريد الالكتروني أو رقم الهاتف',
    enterEmailOrPhone: 'أدخل البريد الالكتروني أو رقم الهاتف',
    emailOrPhoneRequired: 'البريد الالكتروني أو رقم الهاتف مطلوب',
    userName: 'اسم المستخدم',
    signingIn: 'جاري تسجيل الدخول...',
    error: 'خطأ',
    fillAllFields: 'يرجى تعبئة جميع الحقول',
    dontHaveAccount: 'ليس لديك حساب؟',
    signUp: 'إنشاء حساب',
    profileLoadFailed: 'فشل في تحميل بيانات الملف الشخصي',
    profileUpdateFailed: 'فشل في تحديث الملف الشخصي',
    loadingData: 'جاري تحميل البيانات...',
    editProfile: 'تعديل الملف الشخصي',
    changeImage: 'تغيير الصورة',
    examQuestionNumber: 'رقم السؤال',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    qualification: 'المؤهل العلمي',
    passwordPlaceholder: 'كلمة المرور (اتركه فارغاً إذا لم ترد تغييره)',
    saveChanges: 'حفظ التغييرات',
    examDetailsLoadFailed: 'فشل في تحميل تفاصيل الاختبار',
    examInfo: 'معلومات الاختبار',
    studentInfo: 'معلومات الطالب',
    examDeleteSelectedSuccess: 'تم حذف الأسئلة المحددة بنجاح',
    examSaveFailed: 'فشل في حفظ الاختبار',
    confirmDeleteImageTitle: 'حذف الصورة',
    confirmDeleteImageMessage: 'هل أنت متأكد من حذف الصورة؟',
    imageDeleteSuccess: 'تم حذف الصورة بنجاح',
    imageDeleteFailed: 'فشل في حذف الصورة',
    imagePickerError: 'حدث خطأ أثناء اختيار الصورة',
    imageSizeTooLarge: 'يجب أن يكون حجم الصورة أقل من 10 ميجابايت',
    maxImageSizeHint: '(الحد الأقصى 10 ميجابايت)',
    examDetails: 'تفاصيل الاختبار',
    examDurationPlaceholder: 'أدخل مدة الاختبار',
    examDeleteFailed: 'فشل في حذف الأسئلة',
    examNoQuestions: 'لا توجد أسئلة متاحة',
    examDeleteSelected: 'حذف المحدد',
    examStatus: 'حالة الاختبار',
    questionSingular: 'سؤال المفرد',
    questionsPlural: 'أسئلة الجمع',
    examAddQuestion: 'إضافة سؤال',
    examAddFirstQuestion: 'إضافة أول سؤال',
    examEditQuestion: 'تعديل السؤال',
    examCancelQuestion: 'إلغاء',
    examSaveQuestion: 'حفظ السؤال',
    examOption: 'الخيار',
    examQuestionText: 'نص السؤال',
    examQuestionValidationText: 'يرجى إدخال نص السؤال',
    examQuestionValidationOption: 'يرجى إدخال جميع الخيارات',
    examQuestionValidationDuplicate: 'لا يمكن تكرار نفس الخيار',
    examQuestionValidationAnswer: 'يرجى اختيار الإجابة الصحيحة',
    examMaterial: 'المادة',
    examClass: 'الصف',
    examDate: 'تاريخ الاختبار',
    examTime: 'وقت الاختبار',
    examDuration: 'المدة',
    examQuestions: 'الأسئلة',
    examLoading: 'جاري تحميل تفاصيل الاختبار...',
    examDetailsLoading: 'جاري تحميل تفاصيل الاختبار...',
    examEditNotAllowed: 'غير مسموح بتعديل هذا الاختبار',
    examStartFailed: 'فشل في بدء الاختبار',
    examStopFailed: 'فشل في إيقاف الاختبار',
    faildToLoadExams: 'فشل في تحميل الاختبارات',
    examStopConfirm: 'هل أنت متأكد من إيقاف الاختبار؟',
    examStopConfirmMessage: 'سيتم إيقاف الاختبار ولن يمكن التراجع عن هذا الاختيار',
    examStop: 'إيقاف الاختبار',
    examReset: 'إعادة تعيين الاختبار',
    examResetConfirm: 'هل أنت متأكد من إعادة تعيين هذا الاختبار؟',
    examResetNo: 'لا',
    examResetYes: 'نعم',
    examResetFailed: 'فشل في إعادة تعيين الاختبار',
    examDeleteNotAllowed: 'غير مسموح بحذف هذا الاختبار',
    examDeleteConfirm: 'هل أنت متأكد من حذف هذا الاختبار؟',
    examDeleteNo: 'لا',
    examDeleteYes: 'نعم',
    examPrintSuccess: 'تم طباعة الاختبار بنجاح',
    examPrintFailed: 'فشل طباعة الاختبار',
    examPrint: 'طباعة الاختبار',
    examTest: 'اختبار',
    examInstructions: 'التعليمات',
    examAnswerSheet: 'ورقة الاجابة',
    examTotalScore: 'الدرجة الكلية',
    examDegrees: 'الدرجات',
    examResults: 'النتائج',
    viewResults: 'عرض النتائج',
    examAssignUser: 'تعيين مستخدم للاختبار',
    examAssignUserSuccess: 'تم تعيين المستخدم للاختبار بنجاح',
    examAssignUserFailed: 'فشل في تعيين المستخدم للاختبار',
    examAssignUserConfirm: 'هل أنت متأكد من تعيين مستخدم لهذا الاختبار؟',
    examAssignUserConfirmMessage: 'سيتم تعيين المستخدم المحدد لأداء هذا الاختبار',
    examAssignUserYes: 'نعم',
    examAssignUserNo: 'لا',
    failedToLoadExams: 'فشل في تحميل الاختبارات',
    examAssignUserLoading: 'جاري تعيين المستخدم...',
    examSelectStudent: 'اختر الطالب',
    examSelectStudentTitle: 'اختر طالب لتعيينه لهذا الاختبار',
    examSelectStudentPlaceholder: 'اختر طالب...',
    examSelectStudentRequired: 'يرجى اختيار طالب',
    examAssignStudent: 'تعيين الطالب',
    examCancelSelection: 'إلغاء',
    examSubject: 'المادة',
    recentlyAdded: 'المضاف حديثا',
    editExam: 'تعديل الاختبار',
    examStart: 'بدء الاختبار',
    examDelete: 'حذف الاختبار',
    examManagement: 'إدارة الاختبارات',
    examProgress: 'حالة الاختبار',
    addExam: 'إضافة اختبار',
    examSearchPlaceholder: 'ابحث في الاختبارات...',
    examAllStatuses: 'جميع الحالات',
    examOngoing: 'الجارية',
    examCompleted: 'المكتملة',
    examTitleRequired: 'عنوان الاختبار مطلوب',
    examMaterialRequired: 'المادة مطلوبة',
    examClassRequired: 'الصف مطلوب',
    examDateRequired: 'تاريخ الاختبار مطلوب',
    examTimeRequired: 'وقت الاختبار مطلوب',
    examDurationRequired: 'مدة الاختبار مطلوبة',
    allowExamOnMobile: 'السماح بالامتحان على الهاتف المحمول',
    allowExamOnMobileDescription: 'تمكين إجراء الامتحانات على الأجهزة المحمولة',
    failedToUpdateSetting: 'فشل تحديث الإعداد',
    examCancel: 'إلغاء',
    examCancelConfirm: 'هل أنت متأكد من إلغاء؟',
    examCancelNo: 'لا',
    examCancelYes: 'نعم',
    examTitle: 'عنوان الاختبار',
    examTitlePlaceholder: 'أدخل عنوان الاختبار',
    examMaterialSelect: 'اختر المادة',
    examClassSelect: 'اختر الصف',
    examDescription: 'الوصف',
    examStopYes: 'نعم',
    examStopNo: 'لا',
    examDescriptionPlaceholder: 'أدخل وصف الاختبار',
    examQuestionWeight: 'وزن السؤال',
    examQuestionWeightPlaceholder: 'أدخل وزن السؤال',
    examQuestionWeightHint: 'مثال: إذا كان لديك 5 أسئلة والوزن 2، فالمجموع الكلي سيكون 10 نقاط',
    examQuestionWeightRequired: 'وزن السؤال يجب أن يكون 1 على الأقل',
    examRandomQuestions: 'الأسئلة العشوائية',
    examRandomQuestionsLabel: 'تفعيل الأسئلة العشوائية',
    examRandomQuestionsDescription: 'ستظهر الأسئلة بترتيب عشوائي لكل طالب',
    examQuestionOrdering: 'ترتيب الأسئلة',
    examQuestionOrderingDescription: 'استخدم الأسهم لأعلى/لأسفل لإعادة ترتيب الأسئلة',
    examQuestionOrderingDisabled: 'ترتيب الأسئلة معطل عند تفعيل الأسئلة العشوائية',
    examQuestionOrderUpdated: 'تم تحديث ترتيب الأسئلة بنجاح',
    examQuestionOrderUpdateFailed: 'فشل في تحديث ترتيب الأسئلة',
    examNoQuestionsSubtitle: 'ابدأ بإضافة أسئلة أو قم بتحميل ملف',
    examLoadFailed: 'فشل في تحميل بيانات الاختبار',
    examUpdate: 'تحديث',
    examSave: 'حفظ الاختبار',
    language: 'اللغة',
    appLanguage: 'لغة التطبيق',
    appearance: 'المظهر',
    darkMode: 'الوضع الداكن',
    blogManagement: 'إدارة المدونات',
    addNewBlog: 'إضافة مدونة جديدة',
    edit: 'تعديل',
    deleteConfirmation: 'هل أنت متأكد من حذف هذه المدونة؟',
    blogImage: 'صورة المدونة',
    title: 'العنوان',
    enterTitle: 'أدخل العنوان',
    enterDescription: 'أدخل الوصف',
    enterContent: 'أدخل المحتوى',
    saving: 'جاري الحفظ...',
    save: 'حفظ',
    deleting: 'جاري الحذف...',
    blogLoadFailed: 'فشل في تحميل المدونات',
    categoriesLoadFailed: 'فشل في تحميل الفئات',
    blogDeletedSuccess: 'تم حذف المدونة بنجاح',
    blogDeleteFailed: 'فشل في حذف المدونة',
    blogUpdatedSuccess: 'تم تحديث المدونة بنجاح',
    blogCreatedSuccess: 'تم إنشاء المدونة بنجاح',
    blogSaveFailed: 'فشل في حفظ المدونة',
    examCompletion: 'إكمال الاختبار',
    loadingBlogs: 'جاري تحميل المدونات...',
    studentManagement: 'إدارة الطلاب',
    profilePicture: 'صورة الملف الشخصي',
    addStudent: 'إضافة طالب',
    studentLoading: 'جاري تحميل الطلاب...',
    noStudents: 'لا يوجد طلاب',
    studentLoadError: 'فشل في تحميل الطلاب',
    studentDeleteError: 'فشل في حذف الطالب',
    studentStatusError: 'فشل في تحديث حالة الطالب',
    studentDeleteConfirm: 'هل أنت متأكد من حذف',
    studentDeleteAttension: 'سيتم حذف جميع البيانات المرتبطة بالطالب ولا يمكن التراجع',
    editStudent: 'تعديل الطالب',
    active: 'نشط',
    inactive: 'غير نشط',
    class: 'الصف',
    gender: 'الجنس',
    enterFullName: 'أدخل الاسم الكامل',
    selectClass: 'اختر الصف',
    selectMaterial: 'اختر المادة',
    selectImage: 'اختر الصورة',
    enterEmail: 'أدخل البريد الإلكتروني',
    enterPhone: 'أدخل رقم الهاتف',
    emailForParent: 'البريد الإلكتروني لولي الأمر',
    phoneForParent: 'رقم هاتف ولي الأمر',
    enterEmailForParent: 'أدخل البريد الإلكتروني لولي الأمر',
    enterPhoneForParent: 'أدخل رقم هاتف ولي الأمر',
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
    phoneRequired: 'رقم الهاتف مطلوب',
    genderRequired: 'الجنس مطلوب',
    classRequired: 'الصف مطلوب',
    materialRequired: 'المادة مطلوبة',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordOptional: 'كلمة المرور (اختياري)',
    fullNameRequired: 'الاسم الكامل مطلوب',
    studentSaveError: 'فشل في حفظ الطالب',
    studentUpdateSuccess: 'تم تحديث الطالب بنجاح',
    studentAddSuccess: 'تم إضافة الطالب بنجاح',
    examSettings: 'إعدادات الاختبار',
    passingScore: 'درجة النجاح',
    honorBoardExamsCount: 'عدد اختبارات لوحة الشرف',
    honorBoardExamsCountDescription: 'عدد الاختبارات لعرضها في لوحة الشرف (1-50)',
    passingScoreDescription: 'الحد الأدنى للدرجة المطلوبة للنجاح في الاختبار (1-100)',
    failedToSavePassingScore: 'فشل حفظ درجة النجاح',
    noReportYet: 'لا توجد تقارير بعد',
    courses: 'الدورات',
    coupon: 'الكوبون',
    discount: 'الخصم',
    price: 'السعر',
    courseName: 'اسم الدورة',
    courseDescription: 'وصف الدورة',
    coursePrice: 'سعر الدورة',
    courseDiscount: 'خصم الدورة',
    courseHours: 'ساعات الدورة',
    views: 'المشاهدات',
    rate: 'التقييم',
    hours: 'الساعات',
    courseCover: 'غلاف الدورة',
    courseMaterial: 'مادة الدورة',
    courseClass: 'صف الدورة',
    addNewCourse: 'إضافة دورة جديدة',
    courseEdit: 'تعديل الدورة',
    courseDelete: 'حذف الدورة',
    courseSave: 'حفظ الدورة',
    courseUpdate: 'تحديث الدورة',
    courseCancel: 'إلغاء',
    courseCancelConfirm: 'هل أنت متأكد من الإلغاء؟',
    enterCourseName: 'أدخل اسم الدورة',
    enterCourseDescription: 'أدخل وصف الدورة',
    enterCoursePrice: 'أدخل سعر الدورة',
    enterCourseDiscount: 'أدخل خصم الدورة',
    enterCourseHours: 'أدخل ساعات الدورة',
    enterCourseCover: 'أدخل غلاف الدورة',
    enterCouponCode: 'أدخل كود الكوبون',
    enterCouponDescription: 'أدخل وصف الكوبون',
    enterCouponDiscount: 'أدخل خصم الكوبون',
    enterCouponExpiryDate: 'أدخل تاريخ انتهاء الكوبون',
    enterCouponCodeRequired: 'كود الكوبون مطلوب',
    enterCouponDescriptionRequired: 'وصف الكوبون مطلوب',
    enterPrice: 'أدخل السعر',
    clickToUpload: 'اضغط للرفع',
    saveCourse: 'حفظ الدورة',
    enterDiscountOptional: 'أدخل الخصم (اختياري)',
    enterCouponOptional: 'أدخل الكوبون (اختياري)',
    updateCourse: 'تحديث الدورة',
    editCourse: 'تعديل الدورة',
    maintenanceModeTitle: 'وضع الصيانة',
    maintenanceModeActionsDisabledMessage: 'الإجراءات معطلة في وضع الصيانة',
    maintenanceModeActive: 'وضع الصيانة نشط',
    profileUpdateSuccess: 'تم تحديث الملف الشخصي بنجاح',
    noCoursesFound: 'لا توجد دورات',
    noCategoriesFound: 'لا توجد فئات',
    noMaterialsFound: 'لا توجد مواد',
    pullToRefresh: 'اسحب للتحديث',
    examResultNoStudents: 'لا توجد نتائج لهذا الاختبار',
    examResultLoading: 'جاري تحميل النتائج...',
    examResultError: 'فشل في جلب النتائج',
    studentsNotCompletedExam: 'الطلاب الذين لم يكملوا الاختبار',
    studentsCompletedExam: 'الطلاب الذين أكملوا الاختبار',
    statusNotCompleted: 'الحالة: غير مكتمل',
    noStudentsFound: 'لا يوجد طلاب.',
    failedToFetchData: 'فشل في جلب البيانات',
    restartExam: 'إعادة الاختبار',
    restartExamConfirmation: 'هل أنت متأكد أنك تريد إعادة الاختبار لهذا الطالب؟',
    restart: 'إعادة',
    failedToRestart: 'فشل إعادة الاختبار',
    imagePickError: 'فشل في اختيار الصورة',
    storagePermissionRequired: 'مطلوب إذن التخزين',
    fileSelected: 'تم اختيار الملف بنجاح',
    noFileSelected: 'لم يتم اختيار ملف',
    fileProcessedSuccess: 'تم معالجة الملف بنجاح',
    fileProcessError: 'فشل في معالجة الملف',
    processFile: 'معالجة الملف',
    processFileWithAI: 'معالجة بالذكاء الاصطناعي',
    uploadWithAI: 'رفع بالذكاء الاصطناعي',
    selectDocument: 'اختر مستند',
    selectedFile: 'الملف المحدد',
    readyToProcessWithAI: 'جاهز للمعالجة بالذكاء الاصطناعي',
    unknownSize: 'حجم غير معروف',
    chooseFileToUpload: 'اختر ملفاً لرفعه ومعالجته بالذكاء الاصطناعي',
    acceptedFormats: 'الصيغ المقبولة:',
    maxSize: 'الحد الأقصى:',
    chooseFile: 'اختر ملف',
    selectThisFile: 'اختر هذا الملف',
    fileSizeMustBeLess: 'يجب أن يكون حجم الملف أقل من',
    pleaseSelectFileWithTypes: 'يرجى اختيار ملف بإحدى هذه الصيغ:',
    errorReadingFile: 'خطأ في قراءة الملف. يرجى المحاولة مرة أخرى.',
    errorSendingFileData: 'خطأ في إرسال بيانات الملف. يرجى المحاولة مرة أخرى.',
    deleteAllQuestions: 'حذف جميع الأسئلة',
    deleteAllQuestionsConfirm: 'هل أنت متأكد من حذف جميع الأسئلة؟',
    deleteAllQuestionsSuccess: 'تم حذف جميع الأسئلة بنجاح',
    deleteAllQuestionsFailed: 'فشل في حذف جميع الأسئلة',
    noQuestionsToDelete: 'لا توجد أسئلة لحذفها',
    confirmDeleteAllQuestionsTitle: 'حذف جميع الأسئلة',
    confirmDeleteAllQuestionsMessage: 'هل أنت متأكد من حذف جميع الأسئلة؟ لا يمكن التراجع عن هذا الإجراء.',
    confirm: 'تأكيد',
    reportsSubtitle: 'تحليلات وإحصائيات شاملة',
    noReportYetSubtitle: 'لا توجد تقارير متاحة بعد. تحقق لاحقاً!',
    userNotAuthenticated: 'المستخدم غير مصادق عليه',
    failedToLoadProfileData: 'فشل في تحميل بيانات الملف الشخصي',
    imageSelectedSuccessfully: 'تم اختيار الصورة بنجاح',
    free: 'مجاني',
    home: 'الرئيسية',
    manageYourProfile: 'إدارة ملفك الشخصي',
    teacherName: 'اسم المعلم',
    teacherRole: 'دور المعلم',
    personalInformation: 'المعلومات الشخصية',
    accountStats: 'إحصائيات الحساب',
    accountType: 'نوع الحساب',
    accountStatus: 'حالة الحساب',
    somethingWentWrong: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
    manageYourClasses: 'إدارة صفوفك',
    navigation: 'التنقل',
    customizeYourExperience: 'تخصيص تجربتك وتفضيلاتك',
    customizeAppearance: 'تخصيص مظهر التطبيق',
    configureExamPreferences: 'تكوين تفضيلات وقواعد الاختبار',
    settingsFooter: 'يتم حفظ إعداداتك تلقائياً ومزامنتها عبر جميع الأجهزة',
    restartRequired: 'يتطلب إعادة التشغيل',
    restartAppToApplyChanges: 'يرجى إعادة تشغيل التطبيق لتطبيق تغييرات اللغة',
    restartNow: 'إعادة التشغيل الآن',
    later: 'لاحقاً',
    languageChangeFailed: 'فشل في تغيير اللغة',
    saveChangesDescription: 'حفظ إعداداتك الحالية',
    settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح',
    failedToSaveSettings: 'فشل في حفظ الإعدادات',
    cancelling: 'جاري الإلغاء...',
    manageYourExams: 'إدارة وتنظيم اختباراتك بكفاءة',
    completed: 'مكتمل',
    completedStudents: 'الطلاب المكتملين',
    studentsWhoFinishedExam: 'الطلاب الذين أنهوا الاختبار',
    noStudentsCompletedYet: 'لم يكمل أي طالب هذا الاختبار بعد',
    restarting: 'جاري الإعادة',
    tryDifferentSearch: 'جرب البحث بكلمات مختلفة',
    allStudentsCompleted: 'جميع الطلاب أكملوا هذا الاختبار',
    searchQuestions: 'البحث في الأسئلة...',
    noSearchResults: 'لا توجد أسئلة',
    searchResults: 'نتائج البحث',
    clearSearch: 'مسح البحث',
    searchInQuestions: 'البحث في الأسئلة',
    searchInOptions: 'البحث في الخيارات',
    searchInAll: 'البحث في كل شيء',
    manageYourStudents: 'إدارة وتنظيم طلابك بكفاءة',
    studentNoResults: 'لا يوجد طلاب لهذا البحث',
    filter: 'تصفية',
    shareError: 'فشل مشاركة معلومات الطالب',
    copying: 'جاري النسخ...',
    manageYourBlogs: 'إدارة وتنظيم مدوناتك بكفاءة',
    characters: 'أحرف',
    success: 'نجاح',
    ok: 'حسناً',
    signupTitle: 'انضم إلينا كمعلم',
    signupPersonalInfo: 'المعلومات الشخصية',
    signupAcademicInfo: 'المعلومات الأكاديمية',
    signupProfileImageTitle: 'صورة الملف الشخصي (اختياري)',
    signupImagePlaceholder: 'اضغط لاختيار صورة',
    signupImageOptionalHint: 'إضافة صورة اختياري ويمكنك تخطي هذه الخطوة.',
    confirmPassword: 'تأكيد كلمة المرور',
    enterConfirmPassword: 'أعد إدخال كلمة المرور',
    enterQualification: 'أدخل مؤهلك العلمي',
    aboutPlaceholder: 'نبذة عنك وعن خبراتك...',
    signupNext: 'التالي',
    signupPrev: 'السابق',
    signupAsTeacher: 'تسجيل كمعلم',
    confirmPasswordRequired: 'تأكيد كلمة المرور مطلوب',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordMinLength: 'كلمة المرور يجب أن لا تقل عن 6 أحرف',
    signupPhoneInvalid: 'رقم الهاتف يجب أن يبدأ بـ 01 ويكون 11 رقماً',
    signupAboutMax: 'الوصف يجب أن لا يتجاوز 300 حرف',
    signupClassesRequired: 'اختر صفاً واحداً على الأقل',
    otpTitle: 'تأكيد بريدك الإلكتروني',
    otpSubtitle: 'تم إرسال رمز تحقق مكون من 6 أرقام إلى بريدك:',
    otpSending: 'جاري إرسال رمز التحقق...',
    otpSent: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني.',
    otpCodeLabel: 'رمز التحقق',
    otpPlaceholder: 'أدخل الـ 6 أرقام',
    otpVerifying: 'جاري التحقق...',
    otpConfirm: 'تأكيد الرمز',
    otpResend: 'إعادة إرسال الرمز',
    didntReceiveCode: 'لم يصلك الرمز؟',
    otpInvalid: 'رمز التحقق غير صحيح أو منتهي الصلاحية',
    otpSendError: 'حدث خطأ أثناء إرسال رمز التحقق',
    otpVerifyError: 'حدث خطأ أثناء التحقق من الرمز',
    otpVerifySuccess: 'تم التحقق بنجاح، يمكنك تسجيل الدخول الآن.',
    otpMissingData: 'الرجاء العودة والتسجيل من جديد. البيانات غير مكتملة.',
    otpRequired: 'الرجاء إدخال رمز التحقق المكون من 6 أرقام',
    checkWhatsApp: 'تحقق من واتساب',
    codeSentViaWhatsApp: 'تم إرسال رمز التحقق عبر واتساب',
    rafiqWelcome: 'مرحباً! أنا رفيق، مساعدك الذكي لإنشاء أسئلة الاختبارات.',
    rafiqSubtitle: 'مساعدك الذكي لإنشاء أسئلة الاختبارات',
    rafiqInputPlaceholder: 'صف الأسئلة التي تريد إنشاءها...',
    rafiqGenericReply: 'تم استلام طلبك وجاري معالجته.',
    rafiqSelectCountTitle: 'اختر عدد الأسئلة المراد إنشاؤها:',
    rafiqNoDataToAnalyze: 'يبدو أنه لا يوجد بيانات للطالب لتحليلها',
    subscriptionDetails: 'تفاصيل الاشتراك',
    planInformation: 'معلومات الباقة',
    planName: 'اسم الباقة',
    planPeriod: 'مدة الباقة',
    planPrice: 'سعر الباقة',
    subscriptionType: 'نوع الاشتراك',
    subscriptionDates: 'تواريخ الاشتراك',
    day: 'يوم',
    days: 'أيام',
    planFeatures: 'ميزات الباقة',
    notes: 'ملاحظات',
    viewDetails: 'عرض التفاصيل',
    promoted: 'مُرقَّى',
    delayedDays: 'أيام التأخير',
    lastDelayDate: 'تاريخ آخر تأخير',
    timeEstimation: 'تقدير الوقت',
    activeAddons: 'الإضافات الفعالة',
    addonCount: 'إضافة',
    featuredAddon: 'إضافة مميزة',
    addonExtraValue: 'قيمة إضافية',
    noInternetTitle: 'عذراً! لا يوجد اتصال بالإنترنت',
    noInternetSubTitle: 'تحتاج إلى Wi-Fi أو بيانات الجوال للمتابعة',
    noInternetToast: 'لا يزال لا يوجد إنترنت، حاول مرة أخرى',
    refresh: 'حاول مرة أخرى',
    studentLookupsLoadError: 'حدث خطأ أثناء تحميل بيانات الصفوف والمواد',
    studentNotFound: 'لم يتم العثور على الطالب',
    studentProfileLoadError: 'فشل في تحميل بيانات الطالب',
    studentDeleteSuccess: 'تم حذف الطالب بنجاح',
    studentActivateSuccess: 'تم تفعيل الطالب بنجاح',
    studentDeactivateSuccess: 'تم تعطيل الطالب بنجاح',
    currentClass: 'الصف الحالي',
    currentMaterial: 'المادة الحالية',
    nameLettersOnly: 'الاسم يجب أن يحتوي على أحرف فقط',
    studentNameRequired: 'اسم الطالب مطلوب',
    invalidPhoneFormat: 'رقم هاتف غير صحيح',
    passwordMinLengthHint: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    studentImageOptional: 'صورة الطالب (اختياري)',
    studentUpdateError: 'فشل في تحديث بيانات الطالب',
    studentAddFailed: 'فشل في إضافة الطالب',
    notSpecified: 'غير محدد',
    studentInfoLabel: 'معلومات الطالب:',
    namePrefix: 'الاسم:',
    emailPrefix: 'البريد الإلكتروني:',
    phonePrefix: 'رقم الهاتف:',
    usernamePrefix: 'اسم المستخدم:',
    passwordPrefix: 'كلمة المرور:',
    classPrefix: 'الصف:',
    materialPrefix: 'المادة:',
    statusPrefix: 'الحالة:',
    studentIdPrefix: 'رقم الطالب:',
    studentInfoTitlePrefix: 'معلومات الطالب - ',
    studentInfoCopied: 'تم نسخ معلومات الطالب إلى الحافظة',
    addNewStudent: 'إضافة طالب جديد',
    transferClass: 'نقل الطلاب بين الصفوف',
    transferClassTitle: 'نقل الطلاب بين الصفوف',
    oldClass: 'من الصف (القديم)',
    newClass: 'إلى الصف (الجديد)',
    classTransferSuccess: 'تم نقل الطلاب بنجاح',
    classTransferError: 'فشل نقل الطلاب',
    classesMustBeDifferent: 'يجب اختيار صفين مختلفين',
    transferWarningTitle: 'تأكيد نقل الصف الدراسي',
    transferWarningMessage: 'هل أنت متأكد من نقل جميع الطلاب من الصف القديم إلى الصف الجديد؟',
    transferWarningAttention: 'سيقوم هذا بنقل جميع الطلاب المسجلين بالصف. لا يمكن التراجع عن هذا بسهولة.',
    editStudentProfile: 'تعديل بيانات الطالب',
    updateStudentData: 'تحديث البيانات',
    addStudentBtn: 'إضافة الطالب',
    confirmStudentDeleteTitle: 'تأكيد حذف الطالب',
    confirmStudentDeleteMessage: 'هل أنت متأكد من حذف هذا الطالب؟',
    emailLabelPrefix: 'البريد الإلكتروني: ',
    studentIdLabel: 'رقم الطالب',
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    materialLabel: 'المادة',
    viewTooltip: 'عرض',
    shareStudentInfoTooltip: 'مشاركة معلومات الطالب',
    deactivateTooltip: 'تعطيل',
    activateTooltip: 'تفعيل',
    searchStudentsPlaceholder: 'ابحث عن طالب...',
    noStudentsAvailable: 'لا يوجد طلاب متاحة',
    confirmStatusChangeTitle: 'تأكيد تغيير الحالة',
    statusChangeWarningText: 'سيتم منع الطالب من الوصول إلى النظام',
    currencyEGP: 'جنيه',
    noSubscriptionData: 'لا توجد بيانات اشتراك متاحة',
    statusExpired: 'منتهي',
    remainingDaysLabel: 'الأيام المتبقية',
    nDays: '{count} يوم',
    subscriptionPeriod: 'مدة الاشتراك',
    renewSubscription: 'تجديد الاشتراك',
    startDate: 'تاريخ البداية',
    totalDays: 'إجمالي الأيام',
    studentLimit: 'حد الطلاب',
    studentLimitValue: 'باقي {remaining} من إجمالي {limit} طالب',
    storageLimit: 'حد التخزين',
    storageLimitValue: 'باقي {remaining} جيجابايت من إجمالي {limit} جيجابايت',
    delayedDaysTitle: 'أيام التأجيل',
    delayedDaysCount: 'عدد الأيام المؤجلة',
    lastDelayDateLabel: 'آخر تاريخ تأجيل',
    addonsCount: '{count} إضافة',
    availableFeatures: 'الميزات المتاحة',
    featuresCount: '{count} ميزة',
    settingsSaveSuccess: 'تم حفظ التغييرات بنجاح',
    settingsLoadError: 'حدث خطأ أثناء تحميل الإعدادات',
    loadingSettings: 'جاري تحميل الإعدادات...',
    systemSettings: 'إعدادات النظام',
    systemSettingsSubtitle: 'تخصيص تجربة التعليم والامتحانات لتناسب احتياجات طلابك',
    autoAppliedInfoNote: 'يتم تطبيق هذه الإعدادات على جميع الامتحانات الجديدة تلقائياً.',
    examSettingsTitle: 'إعدادات الامتحانات والتقييم',
    examSettingsDescription: 'تحكم في قواعد الامتحانات، الدرجات، ولوحة الشرف',
    defaultPassingScoreLabel: 'نسبة النجاح الافتراضية (%)',
    defaultPassingScoreDesc: 'الحد الأدنى للنسبة المئوية المطلوبة لاجتياز الاختبار',
    allowMobileDevicesLabel: 'السماح بالأجهزة المحمولة',
    allowMobileDevicesDesc: 'تمكين الطلاب من أداء الاختبارات عبر الهواتف الذكية',
    honorBoardExamsCountDesc: 'عدد الاختبارات الأخيرة المحتسبة في تقييم لوحة الشرف',
    blogTitleMinError: 'عنوان المدونة يجب أن يكون 3 أحرف على الأقل',
    blogTitleMaxError: 'عنوان المدونة يجب أن لا يتجاوز 100 حرف',
    blogShortDescription: 'الوصف المختصر',
    blogDescMinError: 'وصف المدونة يجب أن يكون 10 أحرف على الأقل',
    blogDescMaxError: 'وصف المدونة يجب أن لا يتجاوز 400 حرف',
    blogContentMinError: 'محتوى المدونة يجب أن يكون 20 حرف على الأقل',
    blogCategory: 'التصنيف',
    blogDetailsLoadFailed: 'فشل في تحميل بيانات المدونة',
    createNewBlog: 'إنشاء مدونة جديدة',
    updateBlog: 'تحديث المدونة',
    saveBlog: 'حفظ المدونة',
    confirmDeleteBlogTitle: 'تأكيد حذف المدونة',
    categoryPrefix: 'التصنيف: ',
    blogUpdateFailed: 'فشل في تحديث المدونة',
    blogCreateFailed: 'فشل في إضافة المدونة',
    searchBlogPlaceholder: 'ابحث عن مدونة...',
    noBlogsAvailable: 'لا يوجد مدونات متاحة',
    filesCount: '{count} ملف',
    averageTimeTaken: 'متوسط أوقات الاختبارات المنتهية',
    averageTime: 'متوسط الوقت',
    reportDownloadSuccess: 'تم تحميل التقرير بنجاح',
    reportDownloadFailed: 'حدث خطأ أثناء تحميل التقرير',
    recentlyAddedStudents: 'الطلاب المضافون حديثاً',
    passingStudents: 'ناجحون',
    failingStudents: 'راسبون',
    notCompleted: 'غير منجزة',
    passFailRate: 'نسبة النجاح/الرسوب',
    topPerformingStudents: 'أكثر الطلاب تفوقاً',
    monthlyStudentGrowth: 'تطور عدد الطلاب شهرياً',
    completedVsUncompletedExams: 'مقارنة عدد الاختبارات المنجزة وغير المنجزة',
    recentExams: 'الاختبارات الأخيرة',
    exportExamReport: 'تصدير تقرير الاختبارات',
    averageExamGrades: 'متوسط الدرجات للاختبارات',
    averageScoreOverTime: 'متوسط الدرجات عبر الوقت',
    exportStudentReport: 'تصدير تقرير الطلاب',
    freePlan: 'باقة مجانية',
    certifiedTeacher: 'معلم معتمد',
    verifiedAndActive: 'موثق وفعال',
    subscriptionEnd: 'نهاية الاشتراك',
    noActiveSubscription: 'لا يوجد اشتراك',
    basicInformation: 'البيانات الأساسية',
    securityAndPrivacy: 'الأمان والخصوصية',
    subscriptionPlan: 'باقة الاشتراك',
    profileSaveWarningHint: 'سيتم تحديث بياناتك فور الحفظ. تأكد من صحة المعلومات المدخلة.',
    protectYourAccount: 'حماية حسابك',
    passwordEncryptionNotice: 'كلمة المرور الخاصة بك مشفرة ولا يمكن لأحد رؤيتها. لتغييرها، قم بتفعيل وضع التعديل.',
    newPassword: 'كلمة المرور الجديدة',
    leaveBlankToKeepUnchanged: 'اتركها فارغة إذا لم ترد التغيير',
    passwordMinLengthLimit: 'يجب أن تتكون من 6 خانات على الأقل',
    sidebarGeneral: 'عام',
    sidebarAcademic: 'إدارة أكاديمية',
    sidebarOperations: 'إدارة تشغيلية',
    sidebarPlatform: 'إدارة المنصة',
    sidebarGroups: 'المجموعات',
    sidebarToggleTooltip: 'توسيع أو طي القائمة',
    noResultsForThisExam: 'لم يتم العثور على نتائج لهذا الامتحان',
    errorLoadingResults: 'حدث خطأ أثناء تحميل النتائج',
    loadingExamResults: 'جاري تحميل نتائج الامتحان...',
    examMightBeNewOrNotSolved: 'قد يكون الامتحان جديداً أو لم يقم أحد بالحل بعد',
    goBack: 'العودة',
    studentsResultsBoard: 'لوحة نتائج الطلاب',
    viewDetailedStudentStats: 'عرض إحصائيات ونتائج الطلاب المفصلة',
    searchByName: 'البحث بالاسم...',
    found: 'تم العثور على',
    result: 'نتيجة',
    gradesUploadedFromFiles: 'تم رفع الدرجات من الملفات',
    completedFromSystem: 'تم الإكمال من النظام',
    timeLabel: 'الوقت: ',
    minute: 'دقيقة',
    resultSource: 'مصدر النتيجة: ',
    uploadedFromFilesByTeacher: 'مرفوعة من الملفات بواسطة المعلم',
    fromSystemAfterStudentCompletion: 'من النظام بعد إكمال الطالب للاختبار',
    overallPerformance: 'الأداء العام',
    trySearchingWithOtherWords: 'جرب البحث بكلمات أخرى',
    notificationUpdateFailed: 'تعذر تحديث حالة الإشعار',
    markAllReadFailed: 'تعذر تحديد جميع الإشعارات كمقروءة',
    closeNotifications: 'إغلاق الإشعارات',
    defaultUser: 'مستخدم',
    newNotification: 'إشعار جديد',
    notification: 'إشعار',
    updating: 'جاري التحديث...',
    readStatus: 'مقروء',
    unreadStatus: 'غير مقروء',
    loadingMoreNotifications: 'جاري تحميل المزيد...',
    noMoreNotifications: 'لا يوجد المزيد من الإشعارات',
    notificationsTitle: 'الإشعارات',
    analysisGeneratedSuccess: 'تم إنشاء التحليل بنجاح.',
    analysisSuccess: 'تم تحليل الأداء بنجاح',
    analysisFetchError: 'لا يوجد بيانات للطالب أو حدث خطأ أثناء جلب التحليل. يرجى المحاولة مرة أخرى لاحقاً.',
    chatBotHelpMessage: 'حسناً، أنا هنا إذا احتجت إلى أي مساعدة أخرى.',
    reportSentSuccess: 'تم إرسال التقرير إلى ولي الأمر بنجاح',
    reportSentFailed: 'فشل إرسال التقرير',
    reportSentError: 'حدث خطأ أثناء إرسال التقرير',
    loadingStudentData: 'جاري تحميل بيانات الطالب...',
    studentNotFoundTitle: 'لم يتم العثور على الطالب',
    studentNotFoundMessage: 'الطالب المطلوب غير موجود أو تم حذفه',
    smartPerformanceAnalysisReport: 'تقرير تحليل الأداء الذكي',
    generatedByRafiqAI: 'تم التوليد بواسطة رفيق AI',
    sendReportToParentWhatsApp: 'إرسال التقرير لولي الأمر (WhatsApp)',
    analyzeStudentPerformance: 'تحليل أداء الطالب',
    chatBotWelcomeTeacher: 'مرحباً أستاذ {teacherName}! هل تود الحصول على تحليل شامل لأداء الطالب {studentName}؟',
    yesAnalyzePerformance: 'نعم، حلل الأداء',
    noThankYou: 'لا، شكراً',
    studentDataFetchFailed: 'فشل في تحميل بيانات الطالب',
    cvm_videosLoadError: 'تعذر تحميل فيديوهات الدورة',
    cvm_atLeastOneVideoRequired: 'يجب إضافة فيديو واحد على الأقل',
    cvm_notSpecified: 'غير محدد',
    cvm_videosAddedSuccess: 'تم إضافة الفيديوهات بنجاح',
    cvm_videosAddError: 'حدث خطأ أثناء إضافة الفيديوهات',
    cvm_areYouSure: 'هل أنت متأكد؟',
    cvm_cannotRestoreVideo: 'لن تتمكن من استرجاع هذا الفيديو بعد الحذف!',
    cvm_yesDelete: 'نعم، احذف',
    cvm_videoDeletedSuccess: 'تم حذف الفيديو بنجاح',
    cvm_videoDeleteError: 'تعذر حذف الفيديو',
    cvm_backToCourses: 'العودة للدورات',
    cvm_manageVideos: 'إدارة الفيديوهات',
    cvm_videosLibrary: 'مكتبة الفيديوهات',
    cvm_uploadNewVideos: 'رفع فيديوهات جديدة',
    cvm_totalCourseVideosSize: 'إجمالي حجم فيديوهات الدورة',
    cvm_video: 'فيديو',
    cvm_noVideosYet: 'لا توجد فيديوهات حتى الآن',
    cvm_enrichCourseContent: 'ابدأ بإثراء دورتك وإضافة محتوى مرئي للطلاب',
    cvm_addNewVideo: 'إضافة فيديو جديد',
    cvm_videoFromCourse: 'فيديو من دورة',
    cvm_addedRecently: 'أضيف مؤخراً',
    cvm_size: 'الحجم: ',
    cvm_dragToReorder: 'اسحب لترتيب الفيديو',
    cvm_orderSavedSuccess: 'تم حفظ الترتيب بنجاح',
    cvm_orderSaveFailed: 'فشل حفظ الترتيب',
    cvm_saveOrder: 'حفظ الترتيب',
    cvm_manageQuestions: 'إدارة الأسئلة',
    cvm_deleteVideo: 'حذف الفيديو',
    cvm_videoTitleDescription: 'عنوان / وصف الفيديو',
    cvm_videoTitlePlaceholder: 'مثال: الدرس الأول - مقدمة إلى المادة',
    cvm_videoFile: 'ملف الفيديو',
    cvm_dragOrClickVideo: 'انقر أو اسحب لاختيار فيديو',
    cvm_maxVideoSize: 'MP4, WebM (الحد الأقصى 500MB)',
    cvm_chooseVideo: 'اختيار فيديو',
    cvm_changeVideo: 'تغيير الفيديو',
    cvm_addAnotherVideo: 'إضافة فيديو آخر',
    cvm_startUpload: 'بدء عملية الرفع',
    cvm_uploadingProgress: 'جاري الرفع...',
    softGrid_deleteSelectedBtn: 'حذف المحدد',
    softGrid_confirmDeleteSelected: 'هل أنت متأكد من حذف {count} عنصر محدد؟ لا يمكن التراجع عن هذا الإجراء.',
    softGrid_deleteSelectedSuccess: 'تم حذف {count} عنصر بنجاح',
    softGrid_deleteSelectedError: 'فشل في حذف العناصر المحددة',
    teacherDocumentation: 'وثائق المعلم',
    tv_customizeTemplate: 'تخصيص القالب',
    tv_cancel: 'إلغاء',
    tv_saveChanges: 'حفظ التعديلات',
    tv_enterValue: 'أدخل',
    mz_aiStep1: 'ممتاز. ما هو الصف الدراسي؟ (مثال: الصف الثالث الثانوي)',
    mz_aiStep2: 'كم عدد الشرائح التي تريدها؟ (مثال: 10)',
    mz_aiErrCount1: 'يرجى إدخال عدد صحيح أكبر من الصفر.',
    mz_aiErrCount2: 'عذراً، الحد الأقصى لعدد الشرائح هو 10. يرجى إدخال رقم من 1 إلى 10.',
    mz_aiStep3: 'ما هي اللغة المفضلة للشرائح؟',
    mz_aiLangAr: 'العربية',
    mz_aiLangEn: 'English',
    mz_aiStep4: 'هل لديك أي ملاحظات إضافية؟ (يمكنك كتابة \'لا يوجد\')',
    mz_aiStep5: 'تم جمع كافة المعلومات بنجاح. هل تريد تخصيص تصميم العرض (الألوان، الخطوط) أم إنشاء العرض الآن؟',
    mz_aiGenNow: 'إنشاء العرض الآن',
    mz_aiCustStyle: 'تخصيص التصميم',
    mz_aiProcessing: 'جاري المعالجة...',
    mz_aiCustOpening: 'جاري فتح نافذة تخصيص التصميم... بعد الانتهاء انقر على الزر أعلاه للإنشاء.',
    mz_aiGenSent: 'تم إرسال الطلب لإنشاء العرض التقديمي.',
    mz_aiSuccess: 'تم إنشاء العرض التقديمي بنجاح! جاري التحميل...',
    mz_aiPathNotFound: 'لم يتم العثور على مسار الملف في الرد.',
    mz_aiFail: 'فشل إنشاء العرض التقديمي.',
    mz_helperNoteEdit: 'قم برفع ملف جديد لاستبدال المرفقات الحالية (اختياري)',
    mz_helperNoteAdd: 'تحميل المرفقات (صور، PDF، Word، Excel، PPT) - مطلوب',
    mz_pdfWatermarkErr: 'يجب أن تكون جميع الملفات بصيغة PDF عند تفعيل العلامة المائية',
    mz_attachedFile: 'الملف المرفق',
    mz_aiCreateBtnTitle: 'إنشاء عرض AI',
    mz_aiWelcomeMessage: 'أهلاً بك في منشئ العروض التقديمية! ما هو موضوع العرض الذي تريده؟',
    mz_aiBetaHint: 'نسخة تجريبية (Beta)',
    mz_aiOldFilesList: 'إليك ملفاتك السابقة:',
    mz_aiOldFile: 'عرض ملف {count}',
    mz_aiNoOldFiles: 'لا توجد ملفات سابقة.',
    mz_aiOldFilesFail: 'فشل في جلب الملفات السابقة.',
    mz_aiGenSuccessAction: 'تم إنشاء العرض بنجاح! ماذا تريد أن تفعل الآن؟',
    mz_aiViewFile: 'عرض الملف',
    mz_aiDownloadFile: 'تنزيل الملف',
    mz_aiOldFilesHint: 'سيتم حذف الملفات القديمة بعد 7 أيام',
    mz_aiCreateNew: 'إنشاء عرض جديد',
    mz_aiViewOld: 'عرض الملفات السابقة',
    ds_noSteps: 'لا توجد خطوات لعرضها',
    ds_failedSave: 'حدث خطأ أثناء حفظ بيانات الخطوة',
    ds_unexpectedError: 'حدث خطأ غير متوقع',
    ds_submitSuccess: 'تم الإرسال بنجاح',
    ds_submitFailed: 'فشلت عملية الإرسال',
    ds_completedSuccess: 'اكتملت العملية بنجاح',
    ds_processing: 'جاري المعالجة...',
    ds_btnBack: 'السابق',
    ds_btnSubmit: 'تأكيد وإرسال',
    ds_btnNext: 'التالي',
    pptx_topic: 'موضوع العرض',
    pptx_topicPlaceholder: 'أدخل موضوع العرض التقديمي...',
    pptx_grade: 'الصف الدراسي المستهدف',
    pptx_gradePlaceholder: 'أدخل الصف الدراسي...',
    pptx_slidesCount: 'عدد الشرائح (حد أقصى 10)',
    pptx_lang: 'لغة العرض',
    pptx_langAr: 'العربية',
    pptx_langEn: 'الإنجليزية',
    pptx_notes: 'ملاحظات إضافية (اختياري)',
    pptx_notesPlaceholder: 'أي تفاصيل معينة ترغب بإضافتها...',
    pptx_readyTitle: 'جاهز لإنشاء العرض التقديمي!',
    pptx_readyDesc: 'اضغط تأكيد وسيتم تجهيز ملف PowerPoint الخاص بك خلال ثوانٍ.',
    pptx_basicInfo: 'البيانات الأساسية',
    pptx_basicInfoDesc: 'أدخل الموضوع والصف الدراسي.',
    pptx_config: 'إعدادات العرض',
    pptx_configDesc: 'عدد الشرائح ولغة المحتوى.',
    pptx_confirm: 'تأكيد وإنشاء',
    pptx_confirmDesc: 'إضافة ملاحظات وتوليد الملف.',
    pptx_enterTopic: 'يرجى إدخال الموضوع',
    pptx_genSuccess: 'تم إنشاء العرض التقديمي بنجاح!',
    pptx_readyHeader: 'العرض التقديمي جاهز!',
    pptx_btnView: 'عرض الملف',
    pptx_btnDownload: 'تحميل الملف',
    pptx_btnAnother: 'إنشاء ملف آخر',
    pptx_title: 'إنشاء عرض تقديمي بالذكاء الاصطناعي',
    pptx_subtitle: 'اتبع الخطوات لإنشاء ملف PowerPoint لمادتك.',
    // Course Video Manager & Quizzes
    cvm_reorderHintTitle: 'ترتيب الفيديوهات:',
    cvm_reorderHintDesc: 'يمكنك تغيير ترتيب عرض الفيديوهات للطلاب بسهولة من خلال سحب أي فيديو وإسقاطه في المكان المطلوب، ثم الضغط على زر "حفظ الترتيب".',
    cvm_editVideoDescription: 'تعديل وصف الفيديو',
    cvm_editVideoDescriptionTitle: 'تعديل وصف الفيديو',
    cvm_updateDescriptionSuccess: 'تم تحديث وصف الفيديو بنجاح',
    cvm_updateDescriptionError: 'تعذر تحديث وصف الفيديو',
    cvm_uploadHintTitle: 'ملاحظة هامة حول رفع الفيديوهات:',
    cvm_uploadLimitHint: 'لتجنب الضغط والإجهاد على الخادم بسبب حجم البيانات، يُنصح بعدم رفع عدد كبير من الفيديوهات دفعة واحدة (يفضل 3 فيديوهات كحد أقصى في المرة الواحدة) لضمان اكتمال الرفع بنجاح.',
    cvm_uploadMaxThreeRecommended: 'يُنصح برفع 3 فيديوهات كحد أقصى في المرة الواحدة لضمان أداء واستقرار الخادم.',
    cvm_introVideoHintTitle: 'تنبيه:',
    cvm_introVideoHint: 'الفيديو الأول في ترتيب القائمة سيُعرض دائماً كفيديو تعريفي (Intro) للدورة للطلاب.',
    cvm_updateVideoBtn: 'تحديث ملف الفيديو',
    cvm_updateVideoTitle: 'تحديث ملف الفيديو',
    cvm_updateVideoFileLabel: 'ملف الفيديو الجديد',
    cvm_updateVideoFileSubText: 'اختر ملف الفيديو الجديد لاستبدال الحالي (MP4, WebM - حد أقصى 500MB)',
    cvm_updateVideoSubmitBtn: 'تحديث الفيديو',
    cvm_updatingVideoProgress: 'جاري التحديث...',
    cvm_updateVideoSuccess: 'تم تحديث ملف الفيديو بنجاح',
    cvm_updateVideoError: 'تعذر تحديث ملف الفيديو',
    cvm_explanationLabel: 'الشرح (توضيح الإجابة)',
    cvm_timestampLabel: 'وقت ظهور السؤال (بالثواني)',
    cvm_timestampLabelMinutes: 'وقت ظهور السؤال (بالدقائق)',
    cvm_scoreLabel: 'الدرجة',
    cvm_choiceLabel: 'الخيار',
    cvm_isChoiceCorrect: 'هل الخيار {n} صحيح؟',
    cvm_correctOption: 'صحيح',
    cvm_incorrectOption: 'خاطئ',
    cvm_addNewQuestionBtn: 'إضافة سؤال جديد للفيديو',
    cvm_viewManageQuizzes: 'عرض وإدارة أسئلة الكويز',
    cvm_addNewQuestionTitle: 'إضافة سؤال جديد',
    cvm_videoQuizQuestions: 'أسئلة الفيديو (الكويزات)',
    cvm_uniqueChoiceValidation: 'الخيارات يجب أن تكون فريدة',
    cvq_loadingQuestions: 'جاري تحميل الأسئلة...',
    cvq_duplicateOptionError: 'لا يمكن تكرار نفس الخيار أكثر من مرة.',
    cvq_addQuestionSuccess: 'تم إضافة السؤال بنجاح',
    cvq_updateQuestionSuccess: 'تم تحديث السؤال بنجاح',
    cvq_deleteQuestionConfirmTitle: 'تأكيد حذف السؤال',
    cvq_deleteQuestionConfirmMessage: 'هل أنت متأكد من حذف هذا السؤال؟',
    cvm_confirmDeleteVideoTitle: 'تأكيد حذف الفيديو',
    cvm_confirmDeleteVideoMessage: 'هل أنت متأكد من حذف هذا الفيديو؟ سيتم حذف جميع أسئلة الكويز والملفات المرفقة المرتبطة به نهائياً، وسيفقد الطلاب الوصول إليها.',
    cva_addAttachmentBtn: 'إضافة مرفق للفيديو',
    cva_addAttachmentTitle: 'إضافة مرفق جديد',
    cva_attachmentTitleLabel: 'عنوان المرفق',
    cva_attachmentDescLabel: 'وصف المرفق (اختياري)',
    cva_attachmentFileLabel: 'ملف المرفق',
    cva_fileSubText: 'اختر ملف المرفق (PDF, DOCX, صور, إلخ)',
    cva_addAttachmentSuccess: 'تم إضافة المرفق بنجاح',
    cva_addAttachmentError: 'تعذر إضافة المرفق',
    cva_viewAttachmentsBtn: 'عرض وإدارة مرفقات الفيديو',
    cva_videoAttachmentsTitle: 'مرفقات الفيديو',
    cva_noAttachmentsYet: 'لا توجد مرفقات مضافة لهذا الفيديو بعد',
    cva_addAttachmentHint: 'يمكنك إضافة ملفات ومستندات وصور مرفقة من زر إضافة مرفق بطاقة الفيديو',
    cva_editAttachmentTitle: 'تعديل بيانات المرفق',
    cva_deleteAttachmentConfirmTitle: 'تأكيد حذف المرفق',
    cva_deleteAttachmentConfirmMessage: 'هل أنت متأكد من حذف هذا المرفق نهائياً؟',
    cva_updateSuccess: 'تم تحديث المرفق بنجاح',
    cva_updateError: 'فشل تحديث بيانات المرفق',
    cva_deleteSuccess: 'تم حذف المرفق بنجاح',
    cva_deleteError: 'تعذر حذف المرفق',
    cva_downloadFile: 'فتح / تحميل الملف',
    cva_titleLabel: 'عنوان المرفق',
    cva_descLabel: 'الوصف',
    cvm_searchPlaceholder: 'ابحث باسم أو عنوان الفيديو...',
    cvm_noSearchResults: 'لا توجد فيديوهات تطابق البحث',
    limitWarning: 'تنبيه: لقد اقتربت من استهلاك الحد الأقصى المسموح به ',
    forStorageAndStudents: 'للتخزين والطلاب.',
    forStorage: 'للتخزين.',
    forStudents: 'للطلاب.',
    limitWarningforStorage: 'للتخزين.',
    upgradeNow: 'قم بالترقية الآن',
    totalUserCoursesCapacityInMB: 'إجمالي السعة'
  }
};
